import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "order-detail-page bg-gray-100 h-full w-full relative text-base" }
const _hoisted_2 = { class: "bg-green-600 text-white px-3 py-2 flex items-center justify-between sticky top-0 z-10" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-base sm:text-lg font-semibold" }
const _hoisted_5 = { class: "flex items-center space-x-3" }
const _hoisted_6 = { class: "order-summary bg-white px-3 py-2 text-sm" }
const _hoisted_7 = { class: "flex flex-wrap items-center gap-x-4 gap-y-1 text-gray-600" }
const _hoisted_8 = {
  key: 0,
  class: "text-cyan-700 font-medium"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-gray-600" }
const _hoisted_11 = { class: "text-green-600 font-semibold" }
const _hoisted_12 = { class: "flex flex-row min-h-[calc(100dvh-150px)]" }
const _hoisted_13 = { class: "w-full bg-white flex flex-col text-base" }
const _hoisted_14 = { class: "bg-gray-100 px-2 py-1 sticky top-0 z-20" }
const _hoisted_15 = { class: "flex bg-white rounded-lg p-1 shadow-sm" }
const _hoisted_16 = { class: "view-content flex-1 flex flex-col" }
const _hoisted_17 = { class: "px-3 py-1 bg-blue-50 flex flex-wrap gap-2 justify-between items-center text-base border-b" }
const _hoisted_18 = {
  key: 0,
  class: "text-sm text-orange-700"
}
const _hoisted_19 = { class: "flex items-center space-x-3" }
const _hoisted_20 = { class: "text-sm text-blue-600" }
const _hoisted_21 = {
  key: 0,
  class: "flex items-center space-x-2 border-l border-blue-300 pl-3"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "flex-1 overflow-y-auto p-2 text-base" }
const _hoisted_24 = { class: "space-y-2" }
const _hoisted_25 = { class: "order-dish-row" }
const _hoisted_26 = { class: "order-dish-info min-w-0 text-left" }
const _hoisted_27 = { class: "font-medium text-base break-words" }
const _hoisted_28 = {
  key: 0,
  class: "order-item-cook text-sm text-red-600 mt-1"
}
const _hoisted_29 = { class: "order-dish-labels mt-1 flex flex-wrap items-center gap-2 text-xs" }
const _hoisted_30 = { class: "text-sm text-gray-600" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs mt-1"
}
const _hoisted_32 = {
  key: 0,
  class: "inline-flex items-center px-2 py-1 rounded-full text-red-600 bg-red-100"
}
const _hoisted_33 = {
  key: 1,
  class: "inline-flex items-center px-2 py-1 rounded-full text-red-600 bg-red-100"
}
const _hoisted_34 = {
  key: 1,
  class: "inline-flex items-center rounded-full bg-orange-100 px-2 py-1 text-xs text-orange-700"
}
const _hoisted_35 = {
  class: "order-kitchen-progress",
  "aria-label": "厨房制作状态"
}
const _hoisted_36 = ["data-status"]
const _hoisted_37 = { class: "order-kitchen-assignee" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 0,
  class: "order-kitchen-assignee"
}
const _hoisted_40 = { class: "order-dish-serve flex justify-end" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "served-status-badge",
  title: "已上菜"
}
const _hoisted_43 = {
  key: 2,
  class: "cancelled-status-badge",
  title: "已取消"
}
const _hoisted_44 = { class: "order-dish-actions flex flex-col items-end gap-1" }
const _hoisted_45 = { class: "font-semibold text-base" }
const _hoisted_46 = {
  key: 0,
  class: "flex flex-wrap justify-end gap-1"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["disabled", "onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = { class: "p-3 border-t bg-gray-50" }
const _hoisted_53 = { class: "space-y-2" }
const _hoisted_54 = { class: "flex justify-between text-lg" }
const _hoisted_55 = { class: "flex justify-between items-center text-lg" }
const _hoisted_56 = { class: "flex items-center" }
const _hoisted_57 = { class: "flex justify-between items-center text-lg" }
const _hoisted_58 = { class: "flex items-center" }
const _hoisted_59 = { class: "text-green-600" }
const _hoisted_60 = { class: "flex justify-between font-bold text-xl border-t pt-2" }
const _hoisted_61 = { class: "view-content flex-1" }
const _hoisted_62 = { class: "flex h-full" }
const _hoisted_63 = { class: "w-1/4 bg-white overflow-y-auto border-r border-gray-200" }
const _hoisted_64 = { class: "sticky top-0 bg-gray-200 p-3" }
const _hoisted_65 = { class: "relative" }
const _hoisted_66 = { class: "p-3" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "w-2/4 bg-white overflow-y-auto border-r border-gray-200" }
const _hoisted_69 = { class: "p-3 bg-gray-100 sticky top-0 z-10" }
const _hoisted_70 = { class: "font-bold text-xl" }
const _hoisted_71 = { class: "menu-items" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "menu-item-image" }
const _hoisted_74 = ["src", "alt"]
const _hoisted_75 = { class: "menu-item-content" }
const _hoisted_76 = { class: "menu-item-title" }
const _hoisted_77 = { class: "menu-item-desc" }
const _hoisted_78 = { class: "flex justify-between items-center" }
const _hoisted_79 = { class: "menu-item-price" }
const _hoisted_80 = { class: "flex items-center" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 1,
  class: "menu-item-count mr-2"
}
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "flex-1 overflow-y-auto p-3" }
const _hoisted_85 = {
  key: 0,
  class: "text-center text-gray-500 py-12"
}
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "order-item-info" }
const _hoisted_88 = { class: "order-item-name" }
const _hoisted_89 = {
  key: 0,
  class: "order-item-spec text-sm text-gray-500"
}
const _hoisted_90 = { class: "order-item-price" }
const _hoisted_91 = { class: "order-item-controls" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "menu-item-count text-bold mr-2" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "p-3 border-t bg-gray-50" }
const _hoisted_96 = { class: "flex justify-between font-bold text-lg mb-3" }
const _hoisted_97 = { class: "text-sm text-gray-500" }
const _hoisted_98 = { class: "text-green-600" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
  "data-modal": "spec-modal"
}
const _hoisted_101 = { class: "bg-white rounded-xl p-6 w-80 max-w-md" }
const _hoisted_102 = { class: "mb-4 p-3 bg-gray-50 rounded-lg" }
const _hoisted_103 = { class: "flex items-center" }
const _hoisted_104 = ["src", "alt"]
const _hoisted_105 = { class: "font-medium" }
const _hoisted_106 = { class: "text-gray-600 text-sm" }
const _hoisted_107 = { class: "mb-4" }
const _hoisted_108 = { class: "space-y-2" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "font-medium" }
const _hoisted_111 = {
  key: 0,
  class: "fas fa-check text-green-500"
}
const _hoisted_112 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_113 = { class: "text-lg font-medium mb-3" }
const _hoisted_114 = { class: "flex flex-wrap gap-2" }
const _hoisted_115 = ["onClick"]
const _hoisted_116 = {
  key: 1,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_117 = { class: "bg-white rounded-xl p-6 w-96 max-w-md max-h-[90vh] overflow-y-auto" }
const _hoisted_118 = { class: "space-y-4" }
const _hoisted_119 = ["value"]
const _hoisted_120 = {
  key: 2,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_121 = { class: "bg-white rounded-xl p-6 w-96 max-w-md max-h-[90vh] overflow-y-auto" }
const _hoisted_122 = { class: "space-y-4" }
const _hoisted_123 = ["value"]
const _hoisted_124 = {
  key: 3,
  class: "fixed inset-0 bg-black z-50 flex flex-col"
}
const _hoisted_125 = { class: "flex-1 relative overflow-hidden w-full h-full" }
const _hoisted_126 = {
  key: 0,
  class: "absolute inset-0 pointer-events-none z-20"
}
const _hoisted_127 = {
  key: 0,
  class: "bg-black bg-opacity-80 px-4 py-3"
}
const _hoisted_128 = { class: "text-sm font-medium" }
const _hoisted_129 = {
  key: 4,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
}
const _hoisted_130 = { class: "bg-white rounded-xl p-6 w-96 max-w-md" }
const _hoisted_131 = { class: "flex space-x-3" }
const _hoisted_132 = ["disabled"]
const _hoisted_133 = { key: 0 }
const _hoisted_134 = { key: 1 }

import { ref, computed, onMounted, nextTick, onUnmounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { CategoryModel, CategoryItemModel } from '@/model/food';
  import { fetchCategoryItemList, foodUp, fetchCategoryTagList } from '@/service/food';
  import {
    auditOrder,
    getOrder,
    fetchAddFoodWithOrder,
    cancelOrderFood,
    changeOperateStatus,
    changePriority,
    editAmount,
  } from '@/service/order';
  import { showDialog, showToast as showVantToast } from 'vant';
  import { OrderDetailModel, OrderListItemModel } from '@/model/order';
  import { fetchShopList, fetchShopDetail } from '@/service/base';
  import { getOrderTableList, completeOrder, insertOrderPayment } from '@/service/order';
  import { OrderTableListItemModel } from '@/model/order';
  import { OrderPaymentModel } from '@/model/orderPayment';
  import { ShopDetailModel } from '@/model/shop';
  import dayjs from 'dayjs';
  import { dateTimeFormat } from '@/utils/utils';
  import ConfirmDialog from '@/components/ConfirmDialog.vue';
  import { scanPayment, refreshScanPayment } from '@/service/payment';
  import { Html5Qrcode } from 'html5-qrcode';
  import { useCurrentEmployee } from '@/composables/useCurrentEmployee';
  import { fetchOrderKitchenTasks } from '@/service/kitchen';
  import type { FoodOutDetailsListModel } from '@/model/kitchen';

  // 定义菜品项类型
  type DishItem = {
    name: string;
    price: number;
    quantity: number;
    status: 'served' | 'cooking' | 'pending' | 'paused' | 'cancelled';
    originalStatus: number; // 原始状态码
    operateStatus: 'normal' | 'paused' | 'urgent'; // 操作状态：正常、暂停、加急
    priority: number;
    foodSpecName?: string; // 菜品规格名称
    shopFoodId?: number;
    shopFoodSpecId?: number;
    orderFoodId?: number;
    foodCookDesc?: string; // 添加做法描述
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetailView',
  props: {
    detailOrder: {}
  },
  setup(__props: any) {

  const foodDisplayName = (dish: DishItem): string => {
    const spec = dish.foodSpecName?.trim();
    return spec && spec !== '标准' ? `${dish.name}（${spec}）` : dish.name;
  };

  const props = __props;
  const router = useRouter();
  const route = useRoute();
  const { employeeId, employeeName } = useCurrentEmployee();

  // 生成订单编号的辅助函数
  const generateOrderNo = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    const second = String(now.getSeconds()).padStart(2, '0');
    const random = Math.floor(Math.random() * 1000)
      .toString()
      .padStart(3, '0');
    return `${year}${month}${day}${hour}${minute}${second}${random}`;
  };

  // 基础数据
  const tableNumber = ref(0);
  const tableName = ref('');
  const shopId = ref(0);
  const shopName = ref('');
  const orderId = ref(0);
  const peopleCount = ref(4);
  const orderTime = ref('');
  const orderNo = ref('');
  const currentView = ref('ordered');
  const searchKeyword = ref('');
  const selectedCategory = ref('热销推荐');
  const orderPanel = ref<HTMLElement | null>(null);
  const order = ref<OrderDetailModel>({} as OrderDetailModel);

  // 服务费配置（可调整）
  const serviceFeeRate = ref(0); // 服务费比例，0表示无服务费
  const serviceFeeModalVisible = ref(false);
  const tempServiceFeeRate = ref(0);

  // 折扣金额配置
  const discountAmount = ref(0); // 折扣金额
  const discountModalVisible = ref(false);
  const tempDiscountAmount = ref(0);
  const tempDiscountRemark = ref('');

  // 支付确认模态框配置
  const paymentConfirmModalVisible = ref(false);
  const selectedPaymentMethod = ref(4); // 默认选择POS支付
  const paymentRemark = ref('');
  const paymentMethods = [
    { value: 4, name: 'POS支付' },
    { value: 5, name: '公司挂账' },
    { value: 7, name: '现金支付' },
  ];

  // 扫码支付相关状态
  const scanPaymentModalVisible = ref(false);
  const isScanning = ref(false);
  const manualScanCode = ref('');
  const scanPaymentRemark = ref('');
  const scanStatus = ref('');
  const scanStatusClass = ref('');
  const manualInputModalVisible = ref(false);
  const scanPaymentFailModalVisible = ref(false); // 扫码支付失败确认模态框
  const scanPaymentFailErrorMsg = ref(''); // 扫码支付失败错误信息
  const isRefreshingPayment = ref(false); // 是否正在刷新支付状态
  let html5QrCode: Html5Qrcode | null = null;

  // 规格选择相关状态
  const showSpecModalVisible = ref(false);
  const currentFood = ref<any>({});
  const selectedSpec = ref<any>({});
  const selectedMethod = ref(0);
  const selectedMethods = ref<{ [key: string]: number | number[] }>({}); // 支持多个属性选择
  const currentEvent = ref<Event | undefined>(undefined); // 保存原始点击事件
  const methods = ref<
    Array<{
      id: number;
      name: string;
      cookId?: number;
      cookName?: string;
      cookType?: number;
      attributeName?: string; // 新增属性名称字段
    }>
  >([]);

  // 分类数据
  const categories = ref<CategoryModel[]>([]);
  // 所有菜品的完整列表，用于左侧选择“全部”时展示
  const allMenuItems = ref<CategoryItemModel[]>([]);

  // 已点菜品数据 - 改为动态数据
  const currentOrderDishes = ref<DishItem[]>([]);
  const orderKitchenTasks = ref<FoodOutDetailsListModel[]>([]);
  const kitchenStatusReady = ref(false);
  const unstartedOrderFoodIds = ref<Set<number>>(new Set());
  const waiterPauseBusy = ref(false);
  const waiterCancelBusy = ref(false);
  const kitchenStatusMessage = ref('');
  let kitchenStatusLoading = false;
  let kitchenStatusDisposed = false;
  let kitchenStatusTimer: ReturnType<typeof setInterval> | undefined;

  const dishKitchenTasks = (dish: DishItem): FoodOutDetailsListModel[] =>
    dish.orderFoodId
      ? orderKitchenTasks.value.filter((task) => Number(task.orderFoodId) === dish.orderFoodId)
      : [];

  const kitchenTaskStatusText = (task: FoodOutDetailsListModel): string => {
    if (task.status === 999) return '已取消';
    if (task.kitchenStatus === 10) return '制作完成';
    if (task.operateStatus === 1) return '服务员暂停';
    if (task.kitchenStatus === 0) return task.stoveId ? '待制作' : '未分配';
    if (task.kitchenStatus === 5) return '制作中';
    if (task.kitchenStatus === 9) return '厨师暂停';
    return '厨房状态待确认';
  };

  const canWaiterPause = (dish: DishItem): boolean =>
    Boolean(
      dish.orderFoodId &&
        unstartedOrderFoodIds.value.has(dish.orderFoodId) &&
        (dish.status === 'pending' || dish.status === 'cooking') &&
        dish.operateStatus !== 'paused' &&
        ![8, 9, 999].includes(dish.originalStatus),
    );

  const canWaiterKitchenOperate = (dish: DishItem): boolean =>
    Boolean(
      kitchenStatusReady.value &&
        !kitchenStatusMessage.value &&
        dish.orderFoodId &&
        ![1, 10, 999].includes(order.value.orderStatus || 0) &&
        ![8, 9, 999].includes(dish.originalStatus) &&
        dish.status !== 'served' &&
        dish.status !== 'cancelled' &&
        dishKitchenTasks(dish).every(
          (task) => [0, 5, 9].includes(task.kitchenStatus) && ![8, 9, 999].includes(task.status),
        ),
    );

  const canWaiterCancel = (dish: DishItem): boolean =>
    Boolean(
      kitchenStatusReady.value &&
        !kitchenStatusMessage.value &&
        dish.orderFoodId &&
        ![1, 10, 999].includes(order.value.orderStatus || 0) &&
        ![8, 9, 999].includes(dish.originalStatus) &&
        dish.status !== 'cancelled' &&
        dishKitchenTasks(dish).every(
          (task) => task.kitchenStatus === 0 && ![8, 9, 999].includes(task.status),
        ),
    );

  const dishPriority = (dish: DishItem): number => {
    const kitchenTasks = dishKitchenTasks(dish);
    return kitchenTasks.length
      ? Math.max(...kitchenTasks.map((task) => task.priority || 1))
      : dish.priority;
  };

  const isDishUrgent = (dish: DishItem): boolean =>
    dishPriority(dish) >= 999 || dish.operateStatus === 'urgent';

  const loadKitchenMakingState = async (): Promise<boolean> => {
    if (!orderId.value || kitchenStatusLoading || kitchenStatusDisposed) return false;
    const requestedOrderId = orderId.value;
    kitchenStatusLoading = true;
    try {
      const kitchenTasks: FoodOutDetailsListModel[] = [];
      const unstartedIds = new Set<number>();
      const blockedIds = new Set<number>();
      const pageSize = 100;
      let pageNum = 1;
      let loadedCount = 0;
      while (!kitchenStatusDisposed && orderId.value === requestedOrderId) {
        const response = await fetchOrderKitchenTasks({
          pageNum,
          pageSize,
          data: { orderId: requestedOrderId },
        });
        if (kitchenStatusDisposed || orderId.value !== requestedOrderId) return false;
        if (response.code !== 200) throw new Error(response.msg || '读取制作状态失败');
        const list = response.result?.list || [];
        for (const task of list) {
          if (Number(task.orderId) !== requestedOrderId) continue;
          kitchenTasks.push(task);
          const foodId = Number(task.orderFoodId);
          if (
            task.kitchenStatus === 0 &&
            task.operateStatus !== 1 &&
            ![8, 9, 999].includes(task.status)
          )
            unstartedIds.add(foodId);
          else blockedIds.add(foodId);
        }
        loadedCount += list.length;
        if (list.length < pageSize || loadedCount >= response.result.total) break;
        pageNum++;
      }
      orderKitchenTasks.value = kitchenTasks;
      kitchenStatusReady.value = true;
      unstartedOrderFoodIds.value = new Set(
        [...unstartedIds].filter((foodId) => !blockedIds.has(foodId)),
      );
      kitchenStatusMessage.value = '';
      return true;
    } catch (error) {
      console.error('读取订单菜品制作状态失败', error);
      if (!kitchenStatusDisposed && orderId.value === requestedOrderId) {
        orderKitchenTasks.value = [];
        kitchenStatusReady.value = false;
        unstartedOrderFoodIds.value = new Set();
        kitchenStatusMessage.value = '制作状态暂时无法读取，正在重试';
      }
      return false;
    } finally {
      kitchenStatusLoading = false;
    }
  };

  // 加菜订单数据
  const orderItems = ref<
    Array<{
      id: number;
      name: string;
      price: number;
      quantity: number;
      shopFoodSpecId: number;
      specName?: string;
      methodName?: string;
    }>
  >([]);

  // 计算属性
  const filteredMenuItems = computed(() => {
    let items: any[] = [];

    if (selectedCategory.value === '全部') {
      // 如果是"全部"分类，直接展示所有菜品（不再通过标签/分类拼接）
      items = allMenuItems.value;
    } else {
      const selectedCat = categories.value.find((cat) => cat.name === selectedCategory.value);
      items = selectedCat?.items || [];
    }

    if (!searchKeyword.value) return items;
    return items.filter(
      (item) =>
        item.name?.includes(searchKeyword.value) || item.description?.includes(searchKeyword.value),
    );
  });

  const currentDishCount = computed(() => {
    return currentOrderDishes.value
      .filter((dish) => dish.status !== 'cancelled')
      .reduce((sum, dish) => sum + dish.quantity, 0);
  });

  const servedDishCount = computed(() => {
    return currentOrderDishes.value
      .filter((dish) => dish.status === 'served')
      .reduce((sum, dish) => sum + dish.quantity, 0);
  });

  const subtotal = computed(() => {
    return currentOrderDishes.value
      .filter((dish) => dish.status !== 'cancelled')
      .reduce((sum, dish) => sum + dish.price * dish.quantity, 0);
  });

  const serviceFee = computed(() => Math.round(subtotal.value * serviceFeeRate.value));
  const total = computed(() =>
    Math.max(0, subtotal.value + serviceFee.value - discountAmount.value),
  );
  const currentTotal = computed(() => total.value.toFixed(2));

  const orderedTabCount = computed(() => currentDishCount.value);
  const addingTabCount = computed(() =>
    orderItems.value.reduce((sum, item) => sum + item.quantity, 0),
  );
  const orderedCount = computed(() => currentOrderDishes.value.length);

  const orderTotal = computed(() => {
    return orderItems.value.reduce((sum, item) => sum + item.price * item.quantity, 0);
  });

  const totalOrderCount = computed(() => {
    return orderItems.value.reduce((sum, item) => sum + item.quantity, 0);
  });

  const appointmentTimeText = computed(() => {
    const date = order.value.selfPickDate?.trim() || '';
    const time = order.value.selfPickTime?.trim() || '';
    return [date, time].filter(Boolean).join(' ');
  });

  // 检查是否有可操作的菜品（用于批量操作按钮显示）
  const hasOperableDishes = computed(() => {
    return currentOrderDishes.value.some(canWaiterKitchenOperate);
  });

  // 方法
  const getOrderItemCount = (name: string) => {
    const found = orderItems.value.find((item) => item.name === name);
    return found ? found.quantity : 0;
  };

  const getDishStatusClass = (status: string) => {
    const classes: Record<string, string> = {
      served: 'border-l-4 border-green-500 bg-green-50',
      cooking: 'border-l-4 border-yellow-500 bg-yellow-50',
      pending: 'border-l-4 border-blue-500 bg-blue-50',
      paused: 'border-l-4 border-red-500 bg-red-50',
      cancelled: 'border-l-4 border-gray-500 bg-gray-100',
    };
    return classes[status] || classes.pending;
  };

  const getDishStatusTextClass = (status: string) => {
    const classes: Record<string, string> = {
      served: 'text-green-600',
      cooking: 'text-yellow-600',
      pending: 'text-blue-600',
      paused: 'text-red-600',
      cancelled: 'text-gray-600',
    };
    return classes[status] || classes.pending;
  };

  const getDishStatusIcon = (status: string) => {
    const icons: Record<string, string> = {
      served: 'fas fa-check-circle mr-1',
      cooking: 'fas fa-clock mr-1',
      pending: 'fas fa-hourglass-half mr-1',
      paused: 'fas fa-pause-circle mr-1',
      cancelled: 'fas fa-times-circle mr-1',
    };
    return icons[status] || icons.pending;
  };

  // 根据原始状态码获取更准确的状态文本
  const getDishStatusTextByCode = (statusCode: number) => {
    switch (statusCode) {
      case 1:
        return '已点餐';
      case 2:
        return '待出餐';
      case 8:
        return '已出餐';
      case 9:
        return '已上菜';
      case 999:
        return '已取消';
      default:
        return '已点餐';
    }
  };

  const getDishStatusText = (status: string) => {
    const texts: Record<string, string> = {
      served: '已上菜',
      cooking: '待出餐',
      pending: '已点餐',
      paused: '已暂停',
      cancelled: '已取消',
    };
    return texts[status] || texts.pending;
  };

  const selectCategory = (name: string | undefined) => {
    selectedCategory.value = name || '';
  };

  // 加载订单详情数据
  const loadOrderDetail = async () => {
    try {
      if (!orderId.value) {
        console.error('订单ID为空');
        return;
      }

      const response = await getOrder({ orderId: orderId.value });
      if (response.code === 200 && response.result) {
        const orderData = response.result;

        // 更新基础信息
        orderTime.value = orderData.createTime
          ? typeof orderData.createTime === 'string'
            ? orderData.createTime
            : orderData.createTime.toString()
          : '';
        orderNo.value = orderData.orderNo || '';
        peopleCount.value = orderData.personCount || 4;

        // 获取折扣金额
        discountAmount.value = orderData.discountAmount || 0;

        // 转换菜品数据
        if (orderData.foodList && Array.isArray(orderData.foodList)) {
          currentOrderDishes.value = orderData.foodList.map((food: any) => ({
            name: food.foodName || food.shopFoodName || '',
            price: food.price || 0,
            quantity: food.quantity || 1,
            status: mapFoodStatus(food.status || food.foodStatus || 0),
            originalStatus: food.status || food.foodStatus || 0, // 保存原始状态码
            operateStatus: mapOperateStatus(food.operateStatus || food.foodOperateStatus || 0),
            priority: food.priority || 1,
            foodSpecName: food.foodSpecName,
            shopFoodId: food.shopFoodId,
            shopFoodSpecId: food.shopFoodSpecId,
            orderFoodId: food.orderFoodId,
            foodCookDesc: food.foodCookDesc, // 添加做法描述
          }));
        }
        order.value = orderData;
        await loadKitchenMakingState();

        console.log('订单详情加载成功:', orderData);
      } else {
        showDialog({ message: response.msg || '加载订单详情失败' });
      }
    } catch (error) {
      console.error('加载订单详情失败:', error);
      showDialog({ message: '加载订单详情失败，请稍后重试' });
    }
  };

  // 映射菜品状态
  const mapFoodStatus = (
    status: number,
  ): 'served' | 'cooking' | 'pending' | 'paused' | 'cancelled' => {
    switch (status) {
      case 1:
        return 'pending'; // 已点餐
      case 2:
        return 'cooking'; // 待出餐
      case 8:
        return 'cooking'; // 已出餐(可以上菜)
      case 9:
        return 'served'; // 已上菜
      case 999:
        return 'cancelled'; // 已取消
      default:
        return 'pending';
    }
  };

  const mapOperateStatus = (status: number): 'normal' | 'paused' | 'urgent' => {
    switch (status) {
      case 0:
        return 'normal'; // 正常
      case 1:
        return 'paused'; // 暂停
      case 10:
        return 'urgent'; // 加急
      default:
        return 'normal';
    }
  };

  const showSpecDialog = (item: any, event?: Event) => {
    console.log('=== showSpecDialog 调试信息 ===');
    console.log('当前菜品:', item.name);
    console.log('cookList:', item.cookList);
    console.log('cookList长度:', item.cookList?.length);

    currentFood.value = item;
    // 设置默认规格（第一个规格）
    if (item.specs && item.specs.length > 0) {
      selectedSpec.value = item.specs[0];
    } else {
      selectedSpec.value = { id: item.id, name: '标准', price: item.price };
    }

    // 从item.cookList动态获取做法选项
    if (item.cookList && item.cookList.length > 0) {
      console.log('开始解析cookList...');
      methods.value = [];

      item.cookList.forEach((cook: any, cookIndex: number) => {
        console.log(`处理第${cookIndex + 1}个cook:`, cook);
        console.log('cookValue:', cook.cookValue);
        console.log('valueList:', cook.valueList);

        // 解析cookValue JSON字符串
        let cookValues = [];
        try {
          if (cook.cookValue) {
            cookValues = JSON.parse(cook.cookValue);
            console.log('解析cookValue成功:', cookValues);
          } else if (cook.valueList && cook.valueList.length > 0) {
            // 如果cookValue为空，使用valueList
            cookValues = cook.valueList;
            console.log('使用valueList:', cookValues);
          }
        } catch (error) {
          console.error('解析cookValue失败:', error);
          // 如果解析失败，使用valueList作为备用
          if (cook.valueList && cook.valueList.length > 0) {
            cookValues = cook.valueList;
            console.log('解析失败，使用valueList备用:', cookValues);
          }
        }

        // 将解析出的值添加到methods中
        cookValues.forEach((valueItem: any, valueIndex: number) => {
          const value = valueItem.value || valueItem;
          const methodItem = {
            id: cook.cookId * 1000 + valueIndex, // 使用cookId * 1000 + valueIndex作为唯一ID
            name: value,
            cookId: cook.cookId,
            cookName: cook.cookName, // 属性名称，如"做法"、"配菜"
            cookType: cook.cookType,
            attributeName: cook.cookName, // 添加属性名称字段
          };
          methods.value.push(methodItem);
          console.log('添加做法选项:', methodItem);
        });
      });

      console.log('最终methods数组:', methods.value);
      // 设置默认选择第一个做法
      selectedMethod.value = 0;

      // 初始化每个属性的默认选择
      selectedMethods.value = {};
      // 默认不选任何做法（包括常规），无需初始化条目
    } else {
      console.log('没有cookList，使用默认做法（不默认选中）');
      // 如果没有cookList，提供一个"常规"选项，但不默认选中
      methods.value = [{ id: 0, name: '常规' }];
      selectedMethod.value = 0;
      selectedMethods.value = {};
    }

    currentEvent.value = event; // 保存原始点击事件

    // 如果有做法选择，或者有多个规格，都需要弹窗
    if ((item.cookList && item.cookList.length > 0) || (item.specs && item.specs.length > 1)) {
      showSpecModalVisible.value = true;
    } else {
      // 没有做法且只有一个规格，直接添加到订单
      addToOrderWithSpec(item, event);
    }
  };

  const hideSpecModal = () => {
    showSpecModalVisible.value = false;
    currentFood.value = {};
    selectedSpec.value = {};
    selectedMethod.value = 0;
    selectedMethods.value = {}; // 清空多属性选择
    methods.value = []; // 清空做法列表
    currentEvent.value = undefined; // 清空原始点击事件
  };

  const confirmAddToOrder = () => {
    console.log('=== 开始确认添加流程 ===');

    // 添加到订单
    addToOrderWithSpec(currentFood.value, currentEvent.value);

    // 立即开始动画，不等待DOM更新
    setTimeout(() => {
      flyFromSpecModal();
    }, 10);

    // 延长弹窗关闭时间，确保动画可见
    setTimeout(() => {
      hideSpecModal();
    }, 800);
  };

  const flyFromSpecModal = () => {
    console.log('=== 开始飞入动画 ===');
    console.log('当前菜品:', currentFood.value.name);

    // 直接查找当前显示的规格弹窗
    const specModal =
      document.querySelector('[data-modal="spec-modal"]') ||
      document.querySelector('.fixed.inset-0.bg-black.bg-opacity-50:last-child');

    if (!specModal) {
      console.log('❌ 未找到规格弹窗');
      // 尝试备用方案
      const allModals = document.querySelectorAll('.fixed.inset-0.bg-black.bg-opacity-50');
      console.log('找到的所有弹窗:', allModals.length);
      if (allModals.length > 0) {
        const lastModal = allModals[allModals.length - 1];
        console.log('使用最后一个弹窗:', lastModal);
        startAnimation(lastModal);
      }
      return;
    }

    console.log('✅ 找到规格弹窗');
    startAnimation(specModal);
  };

  const startAnimation = (modal: Element) => {
    const img = modal.querySelector('img');
    if (!img) {
      console.log('❌ 未找到图片元素');
      return;
    }
    console.log('✅ 找到图片元素');

    if (!orderPanel.value) {
      console.log('❌ 未找到订单面板');
      return;
    }
    console.log('✅ 找到订单面板');

    const imgRect = img.getBoundingClientRect();
    const orderRect = orderPanel.value.getBoundingClientRect();

    console.log('图片位置:', {
      x: imgRect.left,
      y: imgRect.top,
      w: imgRect.width,
      h: imgRect.height,
    });
    console.log('订单面板位置:', {
      x: orderRect.left,
      y: orderRect.top,
      w: orderRect.width,
      h: orderRect.height,
    });

    // 确保图片有有效的位置信息
    if (imgRect.width === 0 || imgRect.height === 0) {
      console.log('❌ 图片尺寸无效');
      return;
    }

    // 创建克隆图片
    const clone = img.cloneNode(true) as HTMLImageElement;
    clone.style.position = 'fixed';
    clone.style.left = imgRect.left + 'px';
    clone.style.top = imgRect.top + 'px';
    clone.style.width = imgRect.width + 'px';
    clone.style.height = imgRect.height + 'px';
    clone.style.zIndex = '10000';
    clone.style.borderRadius = '8px';
    clone.style.boxShadow = '0 8px 24px rgba(0,0,0,0.5)';
    clone.style.transition = 'all 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    clone.style.pointerEvents = 'none';
    clone.style.opacity = '1';
    clone.style.border = '3px solid #10b981';
    document.body.appendChild(clone);
    console.log('✅ 克隆图片已添加');

    // 计算目标位置
    const targetX = orderRect.left + orderRect.width / 2 - imgRect.width / 2;
    const targetY = orderRect.top + 50;

    console.log('目标位置:', { x: targetX, y: targetY });

    // 开始动画
    setTimeout(() => {
      clone.style.transform = `translate(${targetX - imgRect.left}px, ${
        targetY - imgRect.top
      }px) scale(0.2)`;
      clone.style.opacity = '0.3';
      console.log('🚀 动画已开始');
    }, 100);

    // 清理
    setTimeout(() => {
      if (clone.parentNode) {
        clone.parentNode.removeChild(clone);
        console.log('🧹 动画完成，已清理');
      }
    }, 1600);
  };

  const addToOrderWithSpec = (item: any, event?: Event) => {
    // 使用选中的规格信息
    const specInfo = selectedSpec.value;

    // 生成组合的methodName，包含所有选择的属性（支持多选）
    const methodNames: string[] = [];
    // 按照methods数组的显示顺序来构建methodName
    const attributeGroups: { [key: string]: string[] } = {};

    // 先收集所有选中的做法，按属性分组
    Object.keys(selectedMethods.value).forEach((attributeName) => {
      const selectedIds = selectedMethods.value[attributeName];
      if (Array.isArray(selectedIds)) {
        // 多选：收集选中的做法名称
        const selectedMethodNames = selectedIds
          .map((id) => {
            const method = methods.value.find((m) => m.id === id);
            return method ? method.name : '';
          })
          .filter((name) => name); // 过滤掉空值

        if (selectedMethodNames.length > 0) {
          attributeGroups[attributeName] = selectedMethodNames;
        }
      } else if (selectedIds) {
        // 单选：收集选中的做法名称
        const method = methods.value.find((m) => m.id === selectedIds);
        if (method) {
          attributeGroups[attributeName] = [method.name];
        }
      }
    });

    // 按照methods数组中的显示顺序来构建最终的methodName
    methods.value.forEach((method) => {
      const attributeName = method.attributeName || method.cookName || '做法';
      if (attributeGroups[attributeName] && attributeGroups[attributeName].includes(method.name)) {
        // 如果这个做法被选中了，添加到结果中
        if (!methodNames.includes(`${attributeName}:${method.name}`)) {
          methodNames.push(`${attributeName}:${method.name}`);
        }
      }
    });

    // 按照属性分组重新组织显示格式
    const groupedMethods: { [key: string]: string[] } = {};

    // 将选中的做法按属性分组
    methodNames.forEach((methodName) => {
      const [attributeName, methodValue] = methodName.split(':');
      if (!groupedMethods[attributeName]) {
        groupedMethods[attributeName] = [];
      }
      groupedMethods[attributeName].push(methodValue);
    });

    // 按照属性分组构建最终的显示文本
    const finalMethodNames: string[] = [];
    Object.keys(groupedMethods).forEach((attributeName) => {
      const methods = groupedMethods[attributeName];
      if (methods.length > 0) {
        finalMethodNames.push(`${attributeName}：${methods.join('，')}`);
      }
    });

    const combinedMethodName = finalMethodNames.join('，');

    const orderItem = {
      ...item,
      price: specInfo.price || item.price,
      shopFoodSpecId: specInfo.id || item.id,
      specName: specInfo.name || '标准',
      methodId: selectedMethod.value,
      methodName: combinedMethodName,
    };

    // 1. 订单逻辑
    const found = orderItems.value.find(
      (o) => o.id === item.id && o.shopFoodSpecId === orderItem.shopFoodSpecId,
    );
    if (found) {
      found.quantity += 1;
    } else {
      orderItems.value.push({
        ...orderItem,
        quantity: 1,
        shopFoodSpecId: orderItem.shopFoodSpecId,
      });
    }

    // 2. 动画效果 - 只有在直接点击菜品时才播放flyToOrder动画
    // 如果是从规格弹窗确认添加，则不播放这个动画（会由flyFromSpecModal处理）
    if (event && !showSpecModalVisible.value) {
      nextTick(() => {
        flyToOrder(event);
      });
    }

    console.log('添加到加菜列表:', orderItem);
  };

  const flyToOrder = (event: any) => {
    console.log('开始飞入动画', event);

    const menuItem = event.target.closest('.menu-item');
    if (!menuItem) {
      console.log('未找到menu-item元素');
      return;
    }

    const img = menuItem.querySelector('img');
    if (!img) {
      console.log('未找到图片元素');
      return;
    }

    if (!orderPanel.value) {
      console.log('未找到订单面板元素');
      return;
    }

    const imgRect = img.getBoundingClientRect();
    const orderRect = orderPanel.value.getBoundingClientRect();

    console.log('图片位置:', imgRect);
    console.log('订单面板位置:', orderRect);

    const clone = img.cloneNode(true) as HTMLImageElement;
    clone.style.position = 'fixed';
    clone.style.left = imgRect.left + 'px';
    clone.style.top = imgRect.top + 'px';
    clone.style.width = imgRect.width + 'px';
    clone.style.height = imgRect.height + 'px';
    clone.style.zIndex = '9999';
    clone.style.borderRadius = '8px';
    clone.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
    clone.style.transition = 'all 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    clone.style.pointerEvents = 'none';
    clone.style.opacity = '1';
    document.body.appendChild(clone);

    // 查找订单区中该商品的元素
    let orderTarget = null;
    const orderItemsElements = orderPanel.value.querySelectorAll('.order-item');
    orderItemsElements.forEach((orderItem: any) => {
      const orderName = orderItem.querySelector('.order-item-name');
      if (
        orderName &&
        orderName.textContent ===
          (event.target.closest('.menu-item')?.querySelector('.menu-item-title')?.textContent || '')
      ) {
        orderTarget = orderItem;
      }
    });

    let targetX, targetY;
    if (orderTarget) {
      // 已有该商品，飞向该商品
      const orderItemRect = (orderTarget as HTMLElement).getBoundingClientRect();
      targetX = orderItemRect.left + orderItemRect.width / 2 - imgRect.width / 2;
      targetY = orderItemRect.top + orderItemRect.height / 2 - imgRect.height / 2;
    } else {
      // 没有该商品，飞向订单区顶部
      targetX = orderRect.left + orderRect.width / 2 - imgRect.width / 2;
      targetY = orderRect.top + 30;
    }

    nextTick(() => {
      console.log('目标位置:', { targetX, targetY });

      clone.style.transform = `translate(${targetX - imgRect.left}px, ${
        targetY - imgRect.top
      }px) scale(0.3)`;
      clone.style.opacity = '0.5';
    });

    setTimeout(() => {
      if (clone.parentNode) {
        clone.parentNode.removeChild(clone);
      }
      console.log('动画完成，移除克隆元素');
    }, 1200);
  };

  const switchView = (viewType: string) => {
    currentView.value = viewType;
    if (viewType === 'adding') {
      // 只有在分类数据未加载时才加载，避免重复请求
      if (categories.value.length === 0) {
        setTimeout(() => {
          loadAllCategories();
        }, 100);
      }
    }
  };

  const serveDish = async (dish: DishItem) => {
    confirmMessage.value = `确定要标记 ${dish.name} 为已上菜吗？`;
    confirmTitle.value = '确认上菜';
    if (await confirmDialog.value?.show()) {
      if (!dish.orderFoodId) {
        showToast('菜品信息不完整，无法上菜');
        return;
      }

      try {
        // 调用上菜接口
        const response = await foodUp({
          orderId: orderId.value,
          orderFoodId: dish.orderFoodId,
          shopId: shopId.value,
        });

        if (response.code === 200) {
          // 更新本地状态
          dish.status = 'served';
          showServingSuccess(dish.name);

          // 重新加载订单详情以获取最新状态
          await loadOrderDetail();
        } else {
          showToast(response.msg || '上菜失败，请稍后重试');
        }
      } catch (error) {
        console.error('上菜失败:', error);
        showToast('上菜失败，请稍后重试');
      }
    }
  };

  const callDish = async (dish: DishItem) => {
    if (!canWaiterKitchenOperate(dish)) {
      showToast('菜品已制作完成或状态未确认，不能叫菜');
      return;
    }
    confirmMessage.value = `确定要叫菜 ${dish.name} 吗？`;
    confirmTitle.value = '确认叫菜';
    if (!(await confirmDialog.value?.show())) return;
    try {
      if (!(await loadKitchenMakingState()) || !canWaiterKitchenOperate(dish)) {
        showToast('菜品已制作完成或状态未确认，不能叫菜');
        return;
      }
      const response = await changePriority({
        orderId: orderId.value,
        orderFoodId: dish.orderFoodId,
        shopId: shopId.value,
        priority: 666,
      });
      if (response.code !== 200) throw new Error(response.msg || '叫菜失败');
      showToast(`${dish.name} 已叫菜`);
    } catch (error) {
      console.error('叫菜失败:', error);
      showToast(error instanceof Error ? error.message : '叫菜失败，请稍后重试');
    } finally {
      await loadOrderDetail();
    }
  };

  const sendUrgent = async (dish: DishItem): Promise<void> => {
    if (!canWaiterKitchenOperate(dish)) throw new Error('菜品已制作完成或状态未确认，不能加急');
    const priorityResponse = await changePriority({
      orderId: orderId.value,
      orderFoodId: dish.orderFoodId,
      shopId: shopId.value,
      priority: 999,
    });
    if (priorityResponse.code !== 200) throw new Error(priorityResponse.msg || '加急失败');
  };

  const urgeDish = async (dish: DishItem) => {
    if (!canWaiterKitchenOperate(dish)) {
      showToast('菜品已制作完成或状态未确认，不能加急');
      return;
    }
    // 检查订单状态
    if (order.value.orderStatus === 1) {
      showToast('订单尚未确认，无法进行加急操作');
      return;
    }

    confirmMessage.value = `确定要加急 ${dish.name} 吗？`;
    confirmTitle.value = '确认加急';
    if (await confirmDialog.value?.show()) {
      try {
        if (!(await loadKitchenMakingState()) || !canWaiterKitchenOperate(dish)) {
          showToast('菜品已制作完成或状态未确认，不能加急');
          return;
        }
        await sendUrgent(dish);
        showToast(`${dish.name} 已成功加急`);
      } catch (error) {
        console.error('加急失败:', error);
        showToast(error instanceof Error ? error.message : '加急失败，请稍后重试');
      } finally {
        await loadOrderDetail();
      }
    }
  };

  const pauseDish = async (dish: DishItem): Promise<void> => {
    if (waiterPauseBusy.value) return;
    if (order.value.orderStatus === 1) {
      showToast('订单尚未确认，无法进行暂停操作');
      return;
    }
    if (!canWaiterPause(dish)) {
      showToast('服务员只能暂停尚未开工的菜品');
      return;
    }
    waiterPauseBusy.value = true;
    try {
      confirmMessage.value = `确定要暂停尚未开工的 ${dish.name} 吗？`;
      confirmTitle.value = '确认暂停';
      if (!(await confirmDialog.value?.show())) return;
      if (!(await loadKitchenMakingState())) {
        showToast('制作状态未确认，请稍后再试');
        return;
      }
      if (!canWaiterPause(dish)) {
        showToast('菜品已开工或状态已变化，不能暂停');
        return;
      }
      const response = await changeOperateStatus({
        orderId: orderId.value,
        orderFoodId: dish.orderFoodId,
        shopId: shopId.value,
        operateStatus: 1,
      });
      if (response.code === 200) {
        showToast(`${dish.name} 已暂停`);
        await loadOrderDetail();
      } else {
        showToast(response.msg || '暂停失败，请稍后重试');
      }
    } catch (error) {
      console.error('暂停失败:', error);
      showToast('暂停失败，请稍后重试');
    } finally {
      waiterPauseBusy.value = false;
    }
  };

  const resumeDish = async (dish: DishItem) => {
    if (!canWaiterKitchenOperate(dish)) {
      showToast('菜品已制作完成或状态未确认，不能开始');
      return;
    }
    // 检查订单状态
    if (order.value.orderStatus === 1) {
      showToast('订单尚未确认，无法进行恢复操作');
      return;
    }

    confirmMessage.value = `确定要开始 ${dish.name} 吗？`;
    confirmTitle.value = '确认开始';
    if (await confirmDialog.value?.show()) {
      try {
        if (!(await loadKitchenMakingState()) || !canWaiterKitchenOperate(dish)) {
          showToast('菜品已制作完成或状态未确认，不能开始');
          return;
        }
        const response = await changeOperateStatus({
          orderId: orderId.value,
          orderFoodId: dish.orderFoodId,
          shopId: shopId.value,
          operateStatus: 0, // Swagger：0 表示正常
        });

        if (response.code === 200) {
          // 更新本地状态
          dish.operateStatus = 'normal';
          showToast(`${dish.name} 已开始`);

          // 重新加载订单详情以获取最新状态
          await loadOrderDetail();
        } else {
          showToast(response.msg || '恢复失败，请稍后重试');
        }
      } catch (error) {
        console.error('恢复失败:', error);
        showToast('恢复失败，请稍后重试');
      }
    }
  };

  const cancelDish = async (dish: DishItem): Promise<void> => {
    if (waiterCancelBusy.value) return;
    if (!canWaiterCancel(dish)) {
      showToast('菜品已开工、制作完成或状态未确认，不能取消');
      return;
    }
    waiterCancelBusy.value = true;
    try {
      confirmMessage.value = `确定要取消 ${dish.name} 吗？此操作不可撤销！`;
      confirmTitle.value = '确认取消';
      if (!(await confirmDialog.value?.show())) return;
      if (!(await loadKitchenMakingState())) {
        showToast('制作状态未确认，请稍后再试');
        return;
      }
      if (!canWaiterCancel(dish)) {
        showToast('菜品已开工、制作完成或状态已变化，不能取消');
        return;
      }
      const response = await cancelOrderFood({
        orderId: orderId.value,
        orderFoodId: dish.orderFoodId,
        shopId: shopId.value,
      });
      if (response.code === 200) {
        showToast(`${dish.name} 已取消`);
        await loadOrderDetail();
      } else {
        showToast(response.msg || '取消失败，请稍后重试');
      }
    } catch (error) {
      console.error('取消菜品失败:', error);
      showToast('取消失败，请稍后重试');
    } finally {
      waiterCancelBusy.value = false;
    }
  };

  const batchUrgeDishes = async () => {
    // 检查订单状态
    if (order.value.orderStatus === 1) {
      showToast('订单尚未确认，无法进行批量加急操作');
      return;
    }

    // 筛选可以加急的菜品：未暂停、未完成、未取消
    const urgentableDishes = currentOrderDishes.value
      .filter(canWaiterKitchenOperate)
      .filter((d) => d.status !== 'served' && d.status !== 'cancelled')
      .filter((d) => d.operateStatus === 'normal' && !isDishUrgent(d))
      .filter((d) => d.originalStatus !== 8)
      .filter((d) => d.orderFoodId); // 确保有orderFoodId

    if (urgentableDishes.length === 0) {
      showToast('暂无可以加急的菜品');
      return;
    }

    confirmMessage.value = `确定要对 ${urgentableDishes.length} 道菜品设置加急处理吗？`;
    confirmTitle.value = '批量加急确认';
    if (await confirmDialog.value?.show()) {
      try {
        if (!(await loadKitchenMakingState())) {
          showToast('制作状态未确认，请稍后再试');
          return;
        }
        const eligibleDishes = urgentableDishes.filter(canWaiterKitchenOperate);
        if (!eligibleDishes.length) {
          showToast('菜品已制作完成，暂无可以加急的菜品');
          return;
        }
        const promises = eligibleDishes.map((dish) => sendUrgent(dish));

        const results = await Promise.allSettled(promises);
        const successCount = results.filter((result) => result.status === 'fulfilled').length;

        if (successCount > 0) {
          showToast(`已成功对 ${successCount} 道菜品设置加急处理`);
        } else {
          showToast('批量加急操作失败，请稍后重试');
        }
      } catch (error) {
        console.error('批量加急失败:', error);
        showToast('批量加急操作失败，请稍后重试');
      } finally {
        await loadOrderDetail();
      }
    }
  };

  const batchPauseDishes = async (): Promise<void> => {
    if (waiterPauseBusy.value) return;
    if (order.value.orderStatus === 1) {
      showToast('订单尚未确认，无法进行批量暂停操作');
      return;
    }
    const candidates = currentOrderDishes.value.filter(canWaiterPause);
    if (!candidates.length) {
      showToast('暂无尚未开工且可以暂停的菜品');
      return;
    }
    waiterPauseBusy.value = true;
    try {
      confirmMessage.value = `确定要暂停 ${candidates.length} 道尚未开工的菜品吗？`;
      confirmTitle.value = '批量暂停确认';
      if (!(await confirmDialog.value?.show())) return;
      if (!(await loadKitchenMakingState())) {
        showToast('制作状态未确认，请稍后再试');
        return;
      }
      const pausableDishes = candidates.filter(canWaiterPause);
      if (!pausableDishes.length) {
        showToast('菜品已开工或状态已变化，不能暂停');
        return;
      }
      const results = await Promise.allSettled(
        pausableDishes.map((dish) =>
          changeOperateStatus({
            orderId: orderId.value,
            orderFoodId: dish.orderFoodId,
            shopId: shopId.value,
            operateStatus: 1,
          }),
        ),
      );
      const successCount = results.filter(
        (result) => result.status === 'fulfilled' && result.value.code === 200,
      ).length;
      const skippedCount = candidates.length - pausableDishes.length;
      showToast(
        `已暂停 ${successCount} 道菜${
          skippedCount ? `，跳过 ${skippedCount} 道状态已变化的菜品` : ''
        }${successCount < pausableDishes.length ? '，部分操作失败，请重试' : ''}`,
      );
      await loadOrderDetail();
    } catch (error) {
      console.error('批量暂停失败:', error);
      showToast('批量暂停操作失败，请稍后重试');
    } finally {
      waiterPauseBusy.value = false;
    }
  };

  const batchResumeDishes = async () => {
    // 检查订单状态
    if (order.value.orderStatus === 1) {
      showToast('订单尚未确认，无法进行批量开始操作');
      return;
    }

    // 筛选可以恢复的菜品：暂停状态且未上菜未取消
    const resumableDishes = currentOrderDishes.value
      .filter(canWaiterKitchenOperate)
      .filter((d) => d.operateStatus === 'paused')
      .filter((d) => d.status !== 'served' && d.status !== 'cancelled')
      .filter((d) => d.orderFoodId); // 确保有orderFoodId

    if (resumableDishes.length === 0) {
      showToast('暂无可以开始的菜品');
      return;
    }

    confirmMessage.value = `确定要开始 ${resumableDishes.length} 道菜品吗？`;
    confirmTitle.value = '批量开始确认';
    if (await confirmDialog.value?.show()) {
      try {
        if (!(await loadKitchenMakingState())) {
          showToast('制作状态未确认，请稍后再试');
          return;
        }
        // 批量调用恢复接口
        const eligibleDishes = resumableDishes.filter(canWaiterKitchenOperate);
        if (!eligibleDishes.length) {
          showToast('菜品已制作完成，暂无可以开始的菜品');
          return;
        }
        const promises = eligibleDishes.map((dish) =>
          changeOperateStatus({
            orderId: orderId.value,
            orderFoodId: dish.orderFoodId,
            shopId: shopId.value,
            operateStatus: 0, // Swagger：0 表示正常
          }),
        );

        const results = await Promise.allSettled(promises);
        const successCount = results.filter(
          (result) => result.status === 'fulfilled' && result.value.code === 200,
        ).length;

        if (successCount > 0) {
          showToast(`已开始 ${successCount} 道菜品`);
          // 重新加载订单详情以获取最新状态
          await loadOrderDetail();
        } else {
          showToast('批量开始操作失败，请稍后重试');
        }
      } catch (error) {
        console.error('批量开始失败:', error);
        showToast('批量开始操作失败，请稍后重试');
      }
    }
  };

  const confirmOrderInDetails = async () => {
    // 检查营业时间
    const isBusinessTime = await checkBusinessTime();
    if (!isBusinessTime) {
      return;
    }

    // 检查当前订单状态
    if (order.value.orderStatus !== 1) {
      showToast('订单状态不正确，无法确认');
      return;
    }

    confirmMessage.value = `确定要确认 ${tableName.value} 的订单吗？\n\n确认后订单将发送至厨房开始制作。`;
    confirmTitle.value = '确认订单';
    if (await confirmDialog.value?.show()) {
      try {
        const response = await auditOrder({
          orderId: orderId.value,
          auditStatus: 2, // 2表示确认/审核通过
          shopId: shopId.value,
          remark: `服务员${getEmployeeName()}确认订单`,
        });

        if (response.code === 200) {
          showToast(`${tableName.value}订单已确认！`);
          // 刷新订单详情
          await loadOrderDetail();
        } else {
          showToast(response.msg || '订单确认失败');
        }
      } catch (error) {
        console.error('确认订单失败:', error);
        showToast('确认订单失败，请稍后重试');
      }
    }
  };

  const proceedToCheckout = () => {
    router.push(
      `/orderCheckOut?table=${tableNumber.value}&orderId=${orderId.value}&from=orderDetail&shopId=${shopId.value}`,
    );
  };

  const showOrderHistory = () => {
    router.push('/orderHistory');
  };

  const showServingSuccess = (dishName: string) => {
    // 简化版成功提示
    showToast(`${dishName} 已上菜！`);
  };

  const loadAllCategories = async () => {
    try {
      const [categoryTagResp, itemResp] = await Promise.all([
        fetchCategoryTagList({
          // 新接口不分页，只按店铺查询分类+标签
          shopId: shopId.value || 1,
        }),
        fetchCategoryItemList({
          pageNum: 1,
          pageSize: 999,
          data: { shopId: shopId.value || 1, shopFoodStatus: 0 },
        }),
      ]);

      if (categoryTagResp.code === 200 && itemResp.code === 200) {
        // 分类+标签接口返回数组，为兼容性同时兼容 result.list 结构
        const categoryTagResult: any = categoryTagResp.result;
        const categoryTagList: any[] = Array.isArray(categoryTagResult)
          ? categoryTagResult
          : categoryTagResult?.list || [];
        const foodList: any[] = itemResp.result?.list || [];

        // 先构建所有菜品的完整列表
        const allItems: Array<CategoryItemModel> = [];
        foodList.forEach((item: any) => {
          const specItems: Array<{
            id: number;
            name: string;
            price: number;
            specId: number;
            specName: string;
          }> = [];
          (item.specList || []).forEach((specItem: any) => {
            specItems.push({
              id: specItem.shopFoodSpecId,
              name: specItem.specName,
              price: specItem.price,
              specId: specItem.specId,
              specName: specItem.specName,
            });
          });
          allItems.push({
            id: item.shopFoodId,
            name: item.shopFoodName,
            foodId: item.foodId,
            foodName: item.foodName,
            shopFoodStatus: item.shopFoodStatus,
            price: item.price,
            description: item.shopFoodDesc,
            foodType: item.foodType,
            image: item.imageUrl,
            specs: specItems,
            shopFoodSpecId: specItems.length > 0 ? specItems[0].id : item.shopFoodId,
            cookList: item.cookList || [], // 添加cookList字段
          });
        });
        allMenuItems.value = allItems;

        // 再清空分类并重新构建
        categories.value = [];

        // 「全部」分类
        categories.value.push({
          id: 0,
          name: '全部',
          items: [],
        });

        // 根据返回的 type 构建分类：
        // type = 1 -> 标签：按菜品的 tags 字段模糊匹配
        // type = 2 -> 分类：按原来的分类匹配逻辑（shopFoodCategoryId === id）
        categoryTagList.forEach((ct: any) => {
          const ctId = ct.id;
          const ctName = ct.name;
          const ctType = ct.type; // 1=标签，2=分类

          let originItemList: any[] = [];
          if (ctType === 2) {
            // 分类：按分类ID匹配
            originItemList = foodList.filter((item: any) => item.shopFoodCategoryId === ctId);
          } else if (ctType === 1) {
            // 标签：按 tags 字段模糊匹配
            originItemList = foodList.filter((item: any) => {
              const tagsStr = (item.tags || '') as string;
              return tagsStr
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean)
                .includes(ctName);
            });
          } else {
            // 其他类型暂不处理
            return;
          }

          // 当前分类/标签下的菜品列表（在 allItems 中按 shopFoodId 过滤）
          const items: Array<CategoryItemModel> = allItems.filter((it) =>
            originItemList.some((origin) => origin.shopFoodId === it.id),
          );

          categories.value.push({
            id: ctId,
            name: ctName,
            categoryType: ctType,
            items: items,
          });
        });

        if (categories.value.length > 0) {
          selectedCategory.value = categories.value[0].name || '';
        }
      }
    } catch (error) {
      console.error('加载菜品分类失败：', error);
    }
  };

  const adjustServiceFee = () => {
    // 实现服务费调整逻辑
    console.log('服务费调整逻辑');
  };

  // 编辑折扣金额
  const editDiscountAmount = () => {
    // 检查剩余应付金额 - 如果没有剩余应付金额或金额为0，不允许编辑折扣金额
    if (order.value.remainAmount !== undefined && order.value.remainAmount <= 0) {
      showToast('订单已结清，无法修改折扣金额');
      return;
    }

    tempDiscountAmount.value = discountAmount.value;
    tempDiscountRemark.value = '';
    discountModalVisible.value = true;
  };

  // 保存折扣金额
  const saveDiscountAmount = async () => {
    try {
      // 验证折扣金额不能大于剩余应付金额
      if (
        order.value.remainAmount !== undefined &&
        tempDiscountAmount.value > order.value.remainAmount
      ) {
        showDialog({
          message: `折扣金额不能大于剩余应付金额 ¥${order.value.remainAmount.toFixed(2)}`,
        });
        return;
      }

      // 获取工号
      const employeeId = getEmployeeId();

      // 构建备注信息（工号 + 用户输入的备注）
      const remark = employeeId + (tempDiscountRemark.value ? ': ' + tempDiscountRemark.value : '');

      // 调用接口
      const response = await editAmount({
        orderId: orderId.value,
        discountAmount: tempDiscountAmount.value,
        remark: remark,
      });

      if (response.code === 200) {
        discountAmount.value = tempDiscountAmount.value;
        discountModalVisible.value = false;
        showDialog({ message: '折扣金额设置成功' });
      } else {
        showDialog({ message: response.msg || '设置失败，请稍后重试' });
      }
    } catch (error) {
      console.error('设置折扣金额失败:', error);
      showDialog({ message: '设置失败，请稍后重试' });
    }
  };

  // 取消编辑折扣金额
  const cancelEditDiscount = () => {
    discountModalVisible.value = false;
    tempDiscountAmount.value = 0;
    tempDiscountRemark.value = '';
  };

  // 显示支付确认模态框
  const showPaymentConfirmModal = () => {
    selectedPaymentMethod.value = 4; // 默认选择POS支付
    paymentRemark.value = '';
    paymentConfirmModalVisible.value = true;
  };

  // 隐藏支付确认模态框
  const hidePaymentConfirmModal = () => {
    paymentConfirmModalVisible.value = false;
    selectedPaymentMethod.value = 4;
    paymentRemark.value = '';
  };

  // 确认支付
  const confirmPayment = async () => {
    try {
      if (!order.value.orderId) {
        showToast('订单信息不完整，无法确认支付');
        return;
      }

      const employeeName = getEmployeeName();
      let remark = '';
      let paymentMethodName = '';

      // 根据选择的支付方式设置备注和支付方式名称
      if (selectedPaymentMethod.value === 4) {
        paymentMethodName = 'POS支付';
        remark = `服务员${employeeName}确认POS支付完成，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 5) {
        paymentMethodName = '公司挂账';
        remark = `服务员${employeeName}确认挂账，${paymentRemark.value || ''}`;
      } else if (selectedPaymentMethod.value === 7) {
        paymentMethodName = '现金支付';
        remark = `服务员${employeeName}确认现金支付完成，${paymentRemark.value || ''}`;
      }

      const paymentData: OrderPaymentModel = {
        orderId: order.value.orderId,
        paymentMethod: selectedPaymentMethod.value,
        paymentMethodName: paymentMethodName,
        paymentStatus: 1, // 已支付
        amount: order.value.remainAmount || 0,
        paymentTime: dateTimeFormat(dayjs()),
        remark: remark.trim(),
      };

      const response = await insertOrderPayment(paymentData);
      if (response.code === 200) {
        hidePaymentConfirmModal();
        showToast(`${tableName.value}${paymentMethodName}已确认完成！`);
        // 刷新订单详情
        await loadOrderDetail();
      } else {
        showToast(response.msg || '确认支付失败');
      }
    } catch (error) {
      console.error('确认支付失败:', error);
      showToast('确认支付失败，请稍后重试');
    }
  };

  // 限制只能输入数字（包含小数）
  const handleDiscountInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    // 只允许数字和小数点
    const numericValue = value.replace(/[^\d.]/g, '');
    // 确保只有一个小数点
    const parts = numericValue.split('.');
    if (parts.length > 2) {
      target.value = parts[0] + '.' + parts.slice(1).join('');
    } else {
      target.value = numericValue;
    }
    tempDiscountAmount.value = parseFloat(target.value) || 0;
  };

  const decreaseItem = (name: string) => {
    const idx = orderItems.value.findIndex((item) => item.name === name);
    if (idx !== -1) {
      if (orderItems.value[idx].quantity > 1) {
        orderItems.value[idx].quantity -= 1;
      } else {
        orderItems.value.splice(idx, 1);
      }
    }
  };

  const clearOrder = async () => {
    confirmMessage.value = '确定要清空所有加菜项吗？';
    confirmTitle.value = '清空确认';
    if (await confirmDialog.value?.show()) {
      orderItems.value = [];
    }
  };

  const submitAddOrder = async () => {
    if (orderItems.value.length === 0) return;

    // 检查营业时间
    const canProceed = await checkBusinessTime();
    if (!canProceed) {
      return;
    }

    // 添加详细的调试信息
    console.log('=== 提交加菜订单调试信息 ===');
    console.log('orderItems:', orderItems.value);
    console.log('orderTotal:', orderTotal.value);
    console.log('totalOrderCount:', totalOrderCount.value);
    console.log('peopleCount:', peopleCount.value);
    console.log('tableName:', tableName.value);
    console.log('shopId:', shopId.value);
    console.log('orderId:', orderId.value);
    console.log('orderNo:', orderNo.value);
    console.log('order:', order.value);
    console.log('========================');

    try {
      // 构建符合接口要求的加菜订单数据
      const addFoodData = {
        orderId: orderId.value,
        shopId: shopId.value,
        tableId: tableNumber.value,
        tableUniqueCode: `TABLE_${tableNumber.value}`,
        userId: getEmployeeId(), // 使用保存的工号
        userName: getEmployeeName(), // 使用保存的工号，如果没有则使用默认值
        orderStatus: order.value.orderStatus || 1, // 保持原订单状态
        orderType: order.value.orderType || 1, // 保持原订单类型
        orderChannel: '服务员加菜', // 下单渠道
        dineType: order.value.dineType || 1, // 保持原就餐类型
        personCount: peopleCount.value, // 用餐人数
        totalAmount: orderTotal.value, // 加菜总金额
        discountAmount: 0, // 折扣金额
        foodAmount: orderTotal.value, // 菜品金额
        serviceAmount: 0, // 服务费
        packageAmount: 0, // 包装费
        description: '',
        // description: `${tableName.value}加菜，共${totalOrderCount.value}份菜品`,
        foodList: orderItems.value.map((item) => ({
          shopFoodId: item.id, // 使用菜品ID
          shopFoodSpecId: item.shopFoodSpecId, // 规格ID
          foodCookDesc: item.methodName || '', // 使用组合的methodName作为foodCookDesc
          quantity: item.quantity,
          price: item.price,
          amount: item.price * item.quantity,
          sourcePrice: item.price,
          sourceAmount: item.price * item.quantity,
          priority: 1, // 优先级
          addType: 2, // 添加类型：2-加菜
          addPerson: getEmployeeName(), // 使用保存的工号
        })),
        paymentList: [], // 支付列表，加菜时为空
      };

      console.log('完整加菜订单数据:', addFoodData);

      // 调用加菜接口
      const response = await fetchAddFoodWithOrder(addFoodData);
      if (response.code === 200) {
        console.log('加菜成功:', response.result);
        showToast(
          `${tableName.value}加菜订单已提交！共${totalOrderCount.value}份菜品，金额：¥${orderTotal.value}`,
        );

        // 清空加菜列表
        orderItems.value = [];

        // 重新加载订单详情
        await loadOrderDetail();

        // 切换回已点菜品视图
        currentView.value = 'ordered';
      } else {
        showToast(response.msg || '加菜失败，请稍后重试');
      }
    } catch (error) {
      console.error('提交加菜订单失败:', error);
      showToast('提交加菜订单失败，请稍后重试');
    }
  };

  const refreshKitchenOnResume = (): void => {
    if (document.visibilityState === 'visible' && currentView.value === 'ordered') {
      void loadKitchenMakingState();
    }
  };

  onMounted(async () => {
    if (props.detailOrder) {
      tableNumber.value = props.detailOrder.tableId || 0;
      tableName.value = props.detailOrder.tableName || '';
      shopId.value = props.detailOrder.shopId || 0;
      shopName.value = props.detailOrder.shopName || '';
      orderId.value = props.detailOrder.orderId || 0;
    } else {
      tableNumber.value = Number(route.query.tableNumber) || 0;
      tableName.value = (route.query.tableName as string) || '';
      shopId.value = Number(route.query.shopId) || 0;
      shopName.value = (route.query.shopName as string) || '';
      orderId.value = Number(route.query.orderId) || 0;
    }
    document.addEventListener('visibilitychange', refreshKitchenOnResume);
    window.addEventListener('focus', refreshKitchenOnResume);
    kitchenStatusTimer = setInterval(() => {
      if (currentView.value === 'ordered') void loadKitchenMakingState();
    }, 10000);

    // 加载订单详情
    await loadOrderDetail();
    // 加载店铺详情
    await loadShopDetail();
    // 移除了loadAllCategories()调用，改为在切换到加菜tab时才加载
  });

  // 组件卸载时清理资源
  onUnmounted(() => {
    kitchenStatusDisposed = true;
    document.removeEventListener('visibilitychange', refreshKitchenOnResume);
    window.removeEventListener('focus', refreshKitchenOnResume);
    if (kitchenStatusTimer) clearInterval(kitchenStatusTimer);
    stopScan();
  });

  // 新增：判断是否可以去结账
  const canProceedToCheckout = () => {
    // 如果订单已取消，不能去结账
    if (order.value.orderStatus === 999) {
      return false;
    }

    // 只有线上支付才显示去结账按钮
    if (!isOnlinePayment.value) {
      return false;
    }

    // 检查支付状态 - 如果有支付状态名称，根据支付状态判断
    if (order.value.paymentStatusName) {
      const statusLower = order.value.paymentStatusName.toLowerCase();
      // 如果支付状态包含"已支付"、"支付成功"等关键词，不显示去结账按钮
      if (
        statusLower.includes('已支付') ||
        statusLower.includes('支付成功') ||
        statusLower.includes('paid') ||
        statusLower.includes('success')
      ) {
        return false;
      }
    }

    // 检查剩余应付金额 - 如果没有剩余应付金额或金额为0，不显示去结账按钮
    if (order.value.remainAmount !== undefined && order.value.remainAmount <= 0) {
      return false;
    }

    // 检查订单状态 - 订单必须是已完成(10)或其他可结账状态，且有待支付金额
    if (order.value.orderStatus === 10) {
      // 已完成状态下，只有还有剩余金额才能去结账
      return order.value.remainAmount && order.value.remainAmount > 0;
    }

    // 其他状态默认可以去结账
    return true;
  };

  // 按属性名称分组的计算属性
  const groupedMethods = computed(() => {
    const groups: { [key: string]: any[] } = {};
    methods.value.forEach((method) => {
      const attributeName = method.attributeName || method.cookName || '做法';
      if (!groups[attributeName]) {
        groups[attributeName] = [];
      }
      groups[attributeName].push(method);
    });
    return groups;
  });

  // 从登录态获取工号
  const getEmployeeId = () => {
    return employeeId.value;
  };

  // 从登录态获取员工姓名
  const getEmployeeName = () => {
    return employeeName.value;
  };

  // 店铺详情相关状态
  const shopDetail = ref<ShopDetailModel | null>(null);
  const isOnlinePayment = ref(false); // 是否为线上支付
  const businessTimeList = ref<Array<{ beginTime: string; endTime: string }>>([]);

  // 获取店铺详情
  const loadShopDetail = async () => {
    if (!shopId.value) return;

    try {
      const response = await fetchShopDetail({ shopId: shopId.value });
      if (response.code === 200 && response.result) {
        shopDetail.value = response.result;
        // 判断支付方式：0线下、1线上
        isOnlinePayment.value = response.result.paymentLine === 1;
        // 保存营业时间列表
        businessTimeList.value = response.result.businessTimeList || [];
        console.log('店铺详情加载成功:', response.result);
        console.log('支付方式:', isOnlinePayment.value ? '线上' : '线下');
        console.log('营业时间:', businessTimeList.value);
      }
    } catch (error) {
      console.error('加载店铺详情失败:', error);
    }
  };

  // 检查当前时间是否在营业时间内
  const checkBusinessTime = async (): Promise<boolean> => {
    // 检查是否有营业时间配置
    if (!businessTimeList.value || businessTimeList.value.length === 0) {
      return true;
    }

    // 获取当前时间（HH:mm格式）
    const now = new Date();
    const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(
      now.getMinutes(),
    ).padStart(2, '0')}`;

    // 检查是否在任何一个营业时间段内
    const isInBusinessTime = businessTimeList.value.some((timeSlot) => {
      return currentTime >= timeSlot.beginTime && currentTime <= timeSlot.endTime;
    });

    if (isInBusinessTime) {
      return true;
    }

    // 不在营业时间内，显示确认对话框
    const timeSlots = businessTimeList.value
      .map((slot) => `${slot.beginTime}-${slot.endTime}`)
      .join('、');

    confirmMessage.value = `当前时间 ${currentTime} 不在营业时间内。\n\n营业时间：${timeSlots}\n\n确定要继续操作吗？`;
    confirmTitle.value = '营业时间提醒';
    const result = await confirmDialog.value?.show();
    return result || false;
  };

  // 确认支付完成（线下支付）
  const confirmPaymentComplete = async () => {
    if (!order.value.orderId) {
      showToast('订单信息不完整，无法确认支付');
      return;
    }

    // 显示支付确认模态框
    showPaymentConfirmModal();
  };

  // 显示扫码支付全屏界面
  const showScanPaymentModal = async () => {
    scanPaymentModalVisible.value = true;
    manualScanCode.value = '';
    scanPaymentRemark.value = '';
    scanStatus.value = '';
    // 立即设置为扫描中，避免显示"正在启动摄像头"提示
    isScanning.value = true;
    manualInputModalVisible.value = false;

    // 自动开始扫描
    await nextTick();
    getCamerasInfo();
  };

  // 隐藏扫码支付全屏界面
  const hideScanPaymentModal = () => {
    stopScan();
    scanPaymentModalVisible.value = false;
    manualScanCode.value = '';
    scanPaymentRemark.value = '';
    scanStatus.value = '';
    manualInputModalVisible.value = false;
  };

  // 显示手动输入模态框
  const showManualInputModal = () => {
    manualInputModalVisible.value = true;
  };

  // 隐藏手动输入模态框
  const hideManualInputModal = () => {
    manualInputModalVisible.value = false;
  };

  // 获取摄像头信息并初始化
  const getCamerasInfo = () => {
    // 立即设置为扫描中，隐藏"正在启动摄像头"提示
    isScanning.value = true;

    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          html5QrCode = new Html5Qrcode('qr-reader');
          startScan();
        } else {
          // 没有可用摄像头
          isScanning.value = false;
          scanStatus.value = '未检测到摄像头设备';
          scanStatusClass.value = 'bg-red-100 text-red-700';
        }
      })
      .catch((err) => {
        console.error('获取摄像头失败:', err);
        scanStatus.value = '摄像头无访问权限！';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 开始扫描
  const startScan = () => {
    if (!html5QrCode) {
      console.error('html5QrCode 未初始化');
      return;
    }

    isScanning.value = true;
    scanStatus.value = '';
    scanStatusClass.value = '';

    html5QrCode
      .start(
        { facingMode: 'environment' },
        {
          fps: 20,
          // 全屏扫码：使用整个视窗大小
          qrbox: function (viewfinderWidth, viewfinderHeight) {
            return {
              width: viewfinderWidth,
              height: viewfinderHeight,
            };
          },
          // 不限制宽高比，允许全屏显示
          aspectRatio: undefined,
        },
        (decodedText, decodedResult) => {
          // 扫码成功回调
          handleScanResult(decodedText);
        },
      )
      .then(() => {
        // 扫描启动成功后，强制应用全屏样式
        nextTick(() => {
          forceFullscreenStyles();
        });
      })
      .catch((err) => {
        console.error('扫码失败', err);
        scanStatus.value = '启动摄像头失败，请检查权限设置';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        isScanning.value = false;
      });
  };

  // 强制应用全屏样式
  const forceFullscreenStyles = () => {
    const qrReader = document.getElementById('qr-reader');
    if (!qrReader) return;

    // 强制设置容器样式
    const container = qrReader.querySelector('#html5qr-container');
    if (container) {
      (container as HTMLElement).style.width = '100%';
      (container as HTMLElement).style.height = '100%';
      (container as HTMLElement).style.minWidth = '100%';
      (container as HTMLElement).style.minHeight = '100%';
    }

    // 强制设置视频样式
    const videos = qrReader.querySelectorAll('video');
    videos.forEach((video) => {
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.minWidth = '100%';
      video.style.minHeight = '100%';
      video.style.objectFit = 'cover';
      video.style.position = 'absolute';
      video.style.top = '0';
      video.style.left = '0';
      video.style.right = '0';
      video.style.bottom = '0';
    });

    // 强制设置画布样式
    const canvases = qrReader.querySelectorAll('canvas');
    canvases.forEach((canvas) => {
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.minWidth = '100%';
      canvas.style.minHeight = '100%';
      canvas.style.objectFit = 'cover';
      canvas.style.position = 'absolute';
      canvas.style.top = '0';
      canvas.style.left = '0';
      canvas.style.right = '0';
      canvas.style.bottom = '0';
    });
  };

  // 停止扫描
  const stopScan = () => {
    if (html5QrCode && html5QrCode.isScanning) {
      html5QrCode
        .stop()
        .then(() => {
          html5QrCode?.clear();
          isScanning.value = false;
        })
        .catch((err) => {
          console.error('停止扫描失败:', err);
          isScanning.value = false;
        });
    } else {
      isScanning.value = false;
    }
  };

  // 处理扫描结果
  const handleScanResult = async (scanCode: string) => {
    // 验证扫码结果
    if (!scanCode || scanCode.trim() === '') {
      return;
    }

    // 停止扫描，但保持界面打开
    stopScan();

    // 显示处理中状态
    scanStatus.value = '扫码成功，正在处理支付...';
    scanStatusClass.value = 'bg-blue-100 text-blue-700';

    // 调用支付接口
    await submitScanPayment(scanCode);
  };

  // 处理手动输入的扫码结果
  const handleManualScan = async () => {
    if (!manualScanCode.value || manualScanCode.value.trim() === '') {
      showToast('请输入扫码结果');
      return;
    }

    const scanCode = manualScanCode.value.trim();

    // 关闭手动输入模态框
    manualInputModalVisible.value = false;

    // 停止扫描，但保持界面打开
    stopScan();

    // 显示处理中状态
    scanStatus.value = '正在处理支付...';
    scanStatusClass.value = 'bg-blue-100 text-blue-700';

    // 调用支付接口
    await submitScanPayment(scanCode);
  };

  // 提交扫码支付
  const submitScanPayment = async (scanCode: string) => {
    try {
      if (!order.value.orderId) {
        scanStatus.value = '订单信息不完整，无法支付';
        scanStatusClass.value = 'bg-red-100 text-red-700';
        showToast('订单信息不完整，无法支付');
        return;
      }

      // 获取IP地址（简化处理，实际可以从服务器获取）
      const ip = await getClientIP();

      // 构建支付数据
      const paymentData = {
        orderId: order.value.orderId,
        scanCode: scanCode,
        remark: scanPaymentRemark.value || '',
        ip: ip || '',
        amount: order.value.remainAmount || 0,
      };
      scanPayment;
      // 调用扫码支付接口
      const response = await scanPayment(paymentData);

      // 根据接口返回结果处理
      if (response.code === 200) {
        // API 返回 200，立即关闭扫码界面
        hideScanPaymentModal();

        // 根据业务结果在详情界面显示提示
        if (response.result?.success) {
          // 支付成功，刷新订单详情
          await loadOrderDetail();
          showToast('扫码支付成功！');
        } else {
          // 支付失败，显示确认模态框
          scanPaymentFailErrorMsg.value = response.result?.errorMsg || '';
          scanPaymentFailModalVisible.value = true;
        }
      } else {
        // API 返回非 200，保持界面打开
        const errorMsg = response.msg || '支付失败，请重试';
        scanStatus.value = errorMsg;
        scanStatusClass.value = 'bg-red-100 text-red-700';
        showToast(errorMsg);

        // 重新开始扫描，允许用户继续扫码
        await nextTick();
        getCamerasInfo();
      }
    } catch (error) {
      console.error('扫码支付失败:', error);

      // 显示错误信息，保持界面打开
      scanStatus.value = '支付失败，请稍后重试';
      scanStatusClass.value = 'bg-red-100 text-red-700';
      showToast('支付失败，请稍后重试');

      // 重新开始扫描，允许用户继续扫码
      await nextTick();
      getCamerasInfo();
    }
  };

  // 获取客户端IP地址（简化版本）
  const getClientIP = async (): Promise<string> => {
    // 可以调用后端接口获取真实IP，这里先返回空字符串
    // 或者使用第三方服务获取IP
    return '';
  };

  // 确认已经支付（刷新扫码支付状态）
  const confirmScanPaymentPaid = async () => {
    // 防抖：如果正在刷新，直接返回
    if (isRefreshingPayment.value) {
      return;
    }

    try {
      if (!order.value.orderId) {
        showToast('订单信息不完整，无法确认支付');
        return;
      }

      // 设置 loading 状态
      isRefreshingPayment.value = true;

      const response = await refreshScanPayment({
        orderId: order.value.orderId,
      });

      if (response.code === 200) {
        // 根据业务结果处理
        if (response.result?.success) {
          // 支付成功，关闭模态框并刷新订单详情
          scanPaymentFailModalVisible.value = false;
          scanPaymentFailErrorMsg.value = '';
          showToast('支付成功！');
          // 重新查询订单详情
          await loadOrderDetail();
        } else {
          // 支付失败，显示错误信息，模态框不关闭
          const errorMsg = response.result?.errorMsg || '刷新支付状态失败，请重试';
          scanPaymentFailErrorMsg.value = errorMsg;
          showToast(errorMsg);
        }
      } else {
        // API 返回非 200，显示错误信息，模态框不关闭
        const errorMsg = response.msg || '刷新支付状态失败，请稍后重试';
        scanPaymentFailErrorMsg.value = errorMsg;
        showToast(errorMsg);
      }
    } catch (error) {
      console.error('刷新支付状态失败:', error);
      const errorMsg = '刷新支付状态失败，请稍后重试';
      scanPaymentFailErrorMsg.value = errorMsg;
      showToast(errorMsg);
    } finally {
      // 无论成功失败，都要重置 loading 状态
      isRefreshingPayment.value = false;
    }
  };

  // 取消确认支付
  const cancelScanPaymentConfirm = () => {
    scanPaymentFailModalVisible.value = false;
    scanPaymentFailErrorMsg.value = '';
    isRefreshingPayment.value = false; // 重置 loading 状态
  };

  // 新增：判断是否可以显示确认支付完成按钮
  const canShowConfirmPayment = () => {
    // 如果订单已取消，不能确认支付
    if (order.value.orderStatus === 999) {
      return false;
    }

    // 检查支付状态 - 如果已经支付，不显示确认支付按钮
    if (order.value.paymentStatusName) {
      const statusLower = order.value.paymentStatusName.toLowerCase();
      if (
        statusLower.includes('已支付') ||
        statusLower.includes('支付成功') ||
        statusLower.includes('paid') ||
        statusLower.includes('success')
      ) {
        return false;
      }
    }

    // 检查剩余应付金额 - 如果没有剩余应付金额或金额为0，不显示确认支付按钮
    // if (order.value.remainAmount !== undefined && order.value.remainAmount <= 0) {
    //   return false;
    // }

    // 订单状态为已完成(10)或其他可支付状态，且有待支付金额，则可以显示确认支付完成按钮
    return (
      order.value.orderStatus === 10 ||
      order.value.paymentStatus != 10 ||
      (order.value.remainAmount && order.value.remainAmount > 0)
    );
  };

  // 显示提示消息
  const showToast = (message: string): void => {
    showVantToast({ message, position: 'top', duration: 5000 });
  };

  // 确认对话框相关
  const confirmDialog = ref<InstanceType<typeof ConfirmDialog>>();
  const confirmMessage = ref('');
  const confirmTitle = ref('');

  // 新增：判断是否可以编辑折扣金额
  const canEditDiscountAmount = () => {
    // 检查剩余应付金额 - 如果没有剩余应付金额或金额为0，不允许编辑折扣金额
    if (order.value.remainAmount !== undefined && order.value.remainAmount <= 0) {
      return false;
    }

    return true;
  };

  const toggleMethodSelection = (attributeName: string, methodId: number) => {
    // 找到对应的cookType
    const method = methods.value.find((m) => m.id === methodId);
    const cookType = method?.cookType || 1; // 默认为多选

    if (cookType === 2) {
      // 单选：直接比较
      selectedMethods.value[attributeName] = methodId;
    } else {
      // 多选：支持多个选择
      if (!selectedMethods.value[attributeName]) {
        // 如果该属性还没有选择，初始化为数组
        selectedMethods.value[attributeName] = [methodId];
      } else if (Array.isArray(selectedMethods.value[attributeName])) {
        // 如果已经是数组，切换选择状态
        const currentSelection = selectedMethods.value[attributeName] as number[];
        const index = currentSelection.indexOf(methodId);
        if (index > -1) {
          // 如果已选中，则取消选择
          currentSelection.splice(index, 1);
          // 如果数组为空，删除该属性
          if (currentSelection.length === 0) {
            delete selectedMethods.value[attributeName];
          }
        } else {
          // 如果未选中，则添加选择
          currentSelection.push(methodId);
        }
      } else {
        // 如果之前是单选，转换为多选
        const currentId = selectedMethods.value[attributeName] as number;
        if (currentId === methodId) {
          // 如果点击的是已选中的，则取消选择
          delete selectedMethods.value[attributeName];
        } else {
          // 否则转换为多选
          selectedMethods.value[attributeName] = [currentId, methodId];
        }
      }
    }
  };

  const isMethodSelected = (attributeName: string, methodId: number): boolean => {
    const selection = selectedMethods.value[attributeName];
    // 找到对应的cookType
    const method = methods.value.find((m) => m.id === methodId);
    const cookType = method?.cookType || 1; // 默认为多选

    if (cookType === 2) {
      // 单选：直接比较
      return selection === methodId;
    } else {
      // 多选：检查是否在数组中
      if (Array.isArray(selection)) {
        return selection.includes(methodId);
      }
      return selection === methodId;
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.detailOrder)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/tableManage",
              class: "text-white mr-3"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
              ])),
              _: 1,
              __: [6]
            }))
          : _createCommentVNode("", true),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(shopName.value) + " - " + _toDisplayString(tableName.value) + " - 订单 ", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (currentView.value === 'ordered' && order.value.orderStatus === 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "bg-red-500 hover:bg-red-600 px-4 py-2 rounded-lg font-semibold transition-colors",
              onClick: confirmOrderInDetails
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1),
              _createTextVNode("确认订单 ", -1)
            ])))
          : _createCommentVNode("", true),
        (canShowConfirmPayment())
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "bg-green-500 hover:bg-green-600 px-4 py-2 rounded-lg font-semibold transition-colors mr-2",
              onClick: confirmPaymentComplete
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fas fa-check-circle mr-2" }, null, -1),
              _createTextVNode("确认支付完成 ", -1)
            ])))
          : _createCommentVNode("", true),
        (isOnlinePayment.value && canShowConfirmPayment())
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-lg font-semibold transition-colors",
              onClick: showScanPaymentModal
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "fas fa-qrcode mr-2" }, null, -1),
              _createTextVNode("扫码支付 ", -1)
            ])))
          : _createCommentVNode("", true),
        (!_ctx.detailOrder)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "mr-2",
              onClick: showOrderHistory
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "fas fa-history text-white" }, null, -1)
            ])))
          : _createCommentVNode("", true),
        _cache[11] || (_cache[11] = _createElementVNode("button", null, [
          _createElementVNode("i", { class: "fas fa-ellipsis-v text-white" })
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, "订单号：" + _toDisplayString(orderNo.value), 1),
        _createElementVNode("span", null, "下单：" + _toDisplayString(orderTime.value), 1),
        (appointmentTimeText.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 预约时间：" + _toDisplayString(appointmentTimeText.value), 1))
          : _createCommentVNode("", true),
        (order.value.customerId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "用户：" + _toDisplayString(order.value.customerId), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", null, _toDisplayString(order.value.dineType === 5 ? '预定' : '用餐') + "：" + _toDisplayString(peopleCount.value) + "人", 1),
        _createElementVNode("span", null, "已点 " + _toDisplayString(currentDishCount.value) + "道 · 已上 " + _toDisplayString(servedDishCount.value) + "道", 1),
        _createElementVNode("span", _hoisted_11, "总计 ¥" + _toDisplayString(currentTotal.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: _normalizeClass(["view-tab-btn flex-1 py-2 px-3 rounded-md text-center font-semibold transition-all", { active: currentView.value === 'ordered' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (switchView('ordered')))
            }, [
              _cache[12] || (_cache[12] = _createTextVNode(" 已点菜品 (", -1)),
              _createElementVNode("span", null, _toDisplayString(orderedTabCount.value), 1),
              _cache[13] || (_cache[13] = _createTextVNode(") ", -1))
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["view-tab-btn flex-1 py-2 px-3 rounded-md text-center font-semibold transition-all", { active: currentView.value === 'adding' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (switchView('adding')))
            }, [
              _cache[14] || (_cache[14] = _createTextVNode(" 加菜列表 (", -1)),
              _createElementVNode("span", null, _toDisplayString(addingTabCount.value), 1),
              _cache[15] || (_cache[15] = _createTextVNode(") ", -1))
            ], 2)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "font-bold text-blue-800" }, "已点菜品管理", -1)),
              (kitchenStatusMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(kitchenStatusMessage.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, [
                _cache[17] || (_cache[17] = _createTextVNode("共", -1)),
                _createElementVNode("span", null, _toDisplayString(orderedCount.value), 1),
                _cache[18] || (_cache[18] = _createTextVNode("道菜", -1))
              ]),
              (order.value.orderStatus !== 1 && hasOperableDishes.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "batch-operation-btn bg-red-500 hover:bg-red-600 text-white",
                      title: "批量加急",
                      onClick: batchUrgeDishes
                    }, _cache[19] || (_cache[19] = [
                      _createElementVNode("i", { class: "fas fa-fire mr-1" }, null, -1),
                      _createTextVNode("加急 ", -1)
                    ])),
                    _createElementVNode("button", {
                      class: "batch-operation-btn bg-gray-500 hover:bg-gray-600 text-white",
                      title: "批量暂停",
                      disabled: waiterPauseBusy.value || !currentOrderDishes.value.some(canWaiterPause),
                      onClick: batchPauseDishes
                    }, _cache[20] || (_cache[20] = [
                      _createElementVNode("i", { class: "fas fa-pause mr-1" }, null, -1),
                      _createTextVNode("暂停 ", -1)
                    ]), 8, _hoisted_22),
                    _createElementVNode("button", {
                      class: "batch-operation-btn bg-green-500 hover:bg-green-600 text-white",
                      title: "批量开始",
                      onClick: batchResumeDishes
                    }, _cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "fas fa-play mr-1" }, null, -1),
                      _createTextVNode("开始 ", -1)
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentOrderDishes.value, (dish) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: dish.orderFoodId || dish.name,
                  class: _normalizeClass(["current-order-item px-3 py-2 rounded-r-lg", getDishStatusClass(dish.status)])
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(foodDisplayName(dish)), 1),
                      (dish.foodCookDesc && dish.foodCookDesc.trim() !== '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-utensils mr-1" }, null, -1)),
                            _createTextVNode(_toDisplayString(dish.foodCookDesc), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, "¥" + _toDisplayString(dish.price) + " × " + _toDisplayString(dish.quantity) + "份", 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["text-sm mt-1", getDishStatusTextClass(dish.status)])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(getDishStatusIcon(dish.status))
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(getDishStatusTextByCode(dish.originalStatus)), 1)
                        ], 2),
                        (dish.operateStatus !== 'normal' || isDishUrgent(dish))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (isDishUrgent(dish))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _cache[23] || (_cache[23] = [
                                    _createElementVNode("i", { class: "fas fa-fire mr-1" }, null, -1),
                                    _createTextVNode("已加急 ", -1)
                                  ])))
                                : _createCommentVNode("", true),
                              (dish.operateStatus === 'paused')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _cache[24] || (_cache[24] = [
                                    _createElementVNode("i", { class: "fas fa-pause mr-1" }, null, -1),
                                    _createTextVNode("已暂停 ", -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (dishPriority(dish) === 666 && !isDishUrgent(dish))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, "已叫菜"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dishKitchenTasks(dish), (task) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: task.orderOutId,
                            class: "order-kitchen-task"
                          }, [
                            _createElementVNode("span", {
                              class: "order-kitchen-status",
                              "data-status": 
                            task.status === 999
                              ? 999
                              : task.kitchenStatus === 10
                              ? 10
                              : task.operateStatus === 1
                              ? 9
                              : task.kitchenStatus
                          
                            }, _toDisplayString(kitchenTaskStatusText(task)), 9, _hoisted_36),
                            _createElementVNode("span", _hoisted_37, [
                              _createTextVNode(_toDisplayString(task.kitchenName || '厨房') + " · " + _toDisplayString(task.stoveName ||
                            (task.stoveId
                              ? '厨师待确认'
                              : task.kitchenStatus === 0
                              ? '未分配厨师'
                              : '厨师未记录')) + " ", 1),
                              (dishKitchenTasks(dish).length > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " · " + _toDisplayString(task.quantity) + "份", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        (!dishKitchenTasks(dish).length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(kitchenStatusMessage.value
                            ? '厨房状态暂不可用'
                            : kitchenStatusReady.value
                            ? '暂无厨房任务'
                            : '正在读取厨房状态…'), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (dish.status !== 'served' && dish.status !== 'cancelled')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "serve-btn-large",
                            title: "上菜",
                            onClick: ($event: any) => (serveDish(dish))
                          }, _cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "fas fa-utensils mr-2" }, null, -1),
                            _createTextVNode("上菜 ", -1)
                          ]), 8, _hoisted_41))
                        : (dish.status === 'served')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[26] || (_cache[26] = [
                              _createElementVNode("i", { class: "fas fa-check-circle mr-2" }, null, -1),
                              _createTextVNode("已上菜 ", -1)
                            ])))
                          : (dish.status === 'cancelled')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[27] || (_cache[27] = [
                                _createElementVNode("i", { class: "fas fa-times-circle mr-2" }, null, -1),
                                _createTextVNode("已取消 ", -1)
                              ])))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, "¥" + _toDisplayString(dish.price * dish.quantity), 1),
                      (canWaiterKitchenOperate(dish))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            (
                          dish.status !== 'served' &&
                          dish.status !== 'cancelled' &&
                          dish.originalStatus !== 8 &&
                          dish.operateStatus !== 'paused' &&
                          !isDishUrgent(dish) &&
                          dishPriority(dish) < 666 &&
                          order.value.orderStatus !== 1
                        )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "text-orange-600 hover:text-orange-800",
                                  title: "叫菜",
                                  onClick: ($event: any) => (callDish(dish))
                                }, _cache[28] || (_cache[28] = [
                                  _createElementVNode("i", { class: "fas fa-bullhorn" }, null, -1)
                                ]), 8, _hoisted_47))
                              : _createCommentVNode("", true),
                            (
                          dish.status !== 'served' &&
                          dish.status !== 'cancelled' &&
                          !isDishUrgent(dish) &&
                          dish.operateStatus !== 'paused' &&
                          dish.originalStatus !== 8 &&
                          order.value.orderStatus !== 1
                        )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "text-red-600 hover:text-red-800",
                                  title: "加急",
                                  onClick: ($event: any) => (urgeDish(dish))
                                }, _cache[29] || (_cache[29] = [
                                  _createElementVNode("i", { class: "fas fa-bell" }, null, -1)
                                ]), 8, _hoisted_48))
                              : _createCommentVNode("", true),
                            (canWaiterPause(dish) && order.value.orderStatus !== 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  disabled: waiterPauseBusy.value,
                                  class: "text-gray-600 hover:text-gray-800",
                                  title: "暂停",
                                  onClick: ($event: any) => (pauseDish(dish))
                                }, _cache[30] || (_cache[30] = [
                                  _createElementVNode("i", { class: "fas fa-pause" }, null, -1)
                                ]), 8, _hoisted_49))
                              : _createCommentVNode("", true),
                            (
                          dish.operateStatus === 'paused' &&
                          dish.status !== 'served' &&
                          dish.status !== 'cancelled' &&
                          dish.originalStatus !== 8 &&
                          order.value.orderStatus !== 1
                        )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  class: "text-green-600 hover:text-green-800",
                                  title: "开始",
                                  onClick: ($event: any) => (resumeDish(dish))
                                }, _cache[31] || (_cache[31] = [
                                  _createElementVNode("i", { class: "fas fa-play" }, null, -1)
                                ]), 8, _hoisted_50))
                              : _createCommentVNode("", true),
                            (canWaiterCancel(dish))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  disabled: waiterCancelBusy.value,
                                  class: "text-red-600 hover:text-red-800",
                                  title: "取消",
                                  onClick: ($event: any) => (cancelDish(dish))
                                }, _cache[32] || (_cache[32] = [
                                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                ]), 8, _hoisted_51))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _cache[33] || (_cache[33] = _createElementVNode("span", null, "小计", -1)),
                _createElementVNode("span", null, "¥" + _toDisplayString(subtotal.value.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("span", null, "服务费 (" + _toDisplayString(serviceFeeRate.value * 100) + "%)", 1)
                ]),
                _createElementVNode("span", null, "¥" + _toDisplayString(serviceFee.value.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _cache[35] || (_cache[35] = _createElementVNode("span", null, "折扣金额", -1)),
                  (canEditDiscountAmount())
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "ml-2 text-green-500 hover:text-green-700 text-sm",
                        title: "点击编辑折扣金额",
                        onClick: editDiscountAmount
                      }, _cache[34] || (_cache[34] = [
                        _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_59, "-¥" + _toDisplayString(discountAmount.value.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[36] || (_cache[36] = _createElementVNode("span", null, "总计", -1)),
                _createElementVNode("span", null, "¥" + _toDisplayString(total.value.toFixed(2)), 1)
              ])
            ])
          ])
        ], 512), [
          [_vShow, currentView.value === 'ordered']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchKeyword).value = $event)),
                    type: "text",
                    placeholder: "搜索菜品",
                    class: "w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 text-lg"
                  }, null, 512), [
                    [_vModelText, searchKeyword.value]
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fas fa-search absolute right-3 top-3 text-gray-400" }, null, -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category.id,
                    class: _normalizeClass(["category-item", { active: selectedCategory.value === category.name }]),
                    onClick: ($event: any) => (selectCategory(category.name))
                  }, _toDisplayString(category.name), 11, _hoisted_67))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("h2", _hoisted_70, _toDisplayString(selectedCategory.value), 1)
              ]),
              _createElementVNode("div", _hoisted_71, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenuItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "menu-item",
                    onClick: ($event: any) => (showSpecDialog(item, $event))
                  }, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("img", {
                        src: item.image,
                        alt: item.name,
                        class: "object-cover w-full h-full"
                      }, null, 8, _hoisted_74)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("h3", _hoisted_76, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_77, _toDisplayString(item.description), 1),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("span", _hoisted_79, "¥" + _toDisplayString(item.price), 1),
                        _createElementVNode("div", _hoisted_80, [
                          (getOrderItemCount(item.name) > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "menu-item-btn decrease mr-2",
                                onClick: _withModifiers(($event: any) => (decreaseItem(item.name)), ["stop"])
                              }, "-", 8, _hoisted_81))
                            : _createCommentVNode("", true),
                          (getOrderItemCount(item.name) > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(getOrderItemCount(item.name)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "menu-item-btn increase",
                            onClick: _withModifiers(($event: any) => (showSpecDialog(item, $event)), ["stop"])
                          }, "+", 8, _hoisted_83)
                        ])
                      ])
                    ])
                  ], 8, _hoisted_72))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              ref_key: "orderPanel",
              ref: orderPanel,
              class: "w-1/4 bg-white flex flex-col"
            }, [
              _createElementVNode("div", { class: "p-3 bg-green-50 sticky top-0 z-10 flex justify-between items-center border-b" }, [
                _cache[39] || (_cache[39] = _createElementVNode("h2", { class: "font-bold text-green-800 text-xl" }, "加菜列表", -1)),
                _createElementVNode("button", {
                  class: "text-red-500 text-sm hover:text-red-700",
                  onClick: clearOrder
                }, _cache[38] || (_cache[38] = [
                  _createElementVNode("i", { class: "fas fa-trash-alt mr-1" }, null, -1),
                  _createTextVNode(" 清空 ", -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_84, [
                (orderItems.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, _cache[40] || (_cache[40] = [
                      _createElementVNode("i", { class: "fas fa-plus-circle text-4xl mb-4" }, null, -1),
                      _createElementVNode("p", { class: "text-lg" }, "暂未选择加菜", -1),
                      _createElementVNode("p", { class: "text-sm text-gray-400 mt-2" }, "选择左侧菜品添加", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItems.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.name,
                          class: "order-item text-2xl"
                        }, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, _toDisplayString(item.name), 1),
                            (
                          (item.specName && item.specName !== '标准') ||
                          (item.methodName && item.methodName.trim() !== '')
                        )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                  (item.specName && item.specName !== '标准')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(item.specName), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (item.methodName && item.methodName.trim() !== '')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(item.specName && item.specName !== '标准' ? ' - ' : '') + _toDisplayString(item.methodName), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_90, "¥" + _toDisplayString(item.price) + " × " + _toDisplayString(item.quantity), 1)
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("button", {
                              class: "menu-item-btn decrease mr-2",
                              onClick: ($event: any) => (decreaseItem(item.name))
                            }, "-", 8, _hoisted_92),
                            _createElementVNode("span", _hoisted_93, _toDisplayString(item.quantity), 1),
                            _createElementVNode("button", {
                              class: "menu-item-btn increase",
                              onClick: ($event: any) => (showSpecDialog(item, $event))
                            }, "+", 8, _hoisted_94)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("span", null, [
                    _cache[41] || (_cache[41] = _createTextVNode("加菜总计 ", -1)),
                    _createElementVNode("span", _hoisted_97, "（共" + _toDisplayString(totalOrderCount.value) + "份）", 1)
                  ]),
                  _createElementVNode("span", _hoisted_98, "¥" + _toDisplayString(orderTotal.value.toFixed(2)), 1)
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-lg font-bold text-xl transition-colors", { 'opacity-50': orderItems.value.length === 0 }]),
                  disabled: orderItems.value.length === 0,
                  onClick: submitAddOrder
                }, " 提交加菜 ", 10, _hoisted_99)
              ])
            ], 512)
          ])
        ], 512), [
          [_vShow, currentView.value === 'adding']
        ])
      ])
    ]),
    (showSpecModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
              _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "text-xl font-bold" }, "选择规格", -1)),
              _createElementVNode("button", { onClick: hideSpecModal }, _cache[42] || (_cache[42] = [
                _createElementVNode("i", { class: "fas fa-times text-gray-500" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("img", {
                  src: currentFood.value.image,
                  alt: currentFood.value.name,
                  class: "w-16 h-16 rounded-lg mr-3 object-cover"
                }, null, 8, _hoisted_104),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_105, _toDisplayString(currentFood.value.name), 1),
                  _createElementVNode("p", _hoisted_106, _toDisplayString(currentFood.value.description), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              _cache[44] || (_cache[44] = _createElementVNode("h4", { class: "text-lg font-medium mb-3" }, "选择规格", -1)),
              _createElementVNode("div", _hoisted_108, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentFood.value.specs || [], (spec) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: spec.id,
                    class: _normalizeClass(["w-full p-3 rounded-lg border flex items-center justify-between", 
                selectedSpec.value.id === spec.id ? 'border-green-500 bg-green-50' : 'border-gray-300'
              ]),
                    onClick: ($event: any) => (selectedSpec.value = spec)
                  }, [
                    _createElementVNode("span", null, _toDisplayString(spec.name), 1),
                    _createElementVNode("span", _hoisted_110, "¥" + _toDisplayString(spec.price), 1),
                    (selectedSpec.value.id === spec.id)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_111))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_109))
                }), 128))
              ])
            ]),
            (methods.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedMethods.value, (attributeGroup, attributeName) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: attributeName,
                      class: "mb-4"
                    }, [
                      _createElementVNode("h4", _hoisted_113, "选择" + _toDisplayString(attributeName), 1),
                      _createElementVNode("div", _hoisted_114, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributeGroup, (method) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: method.id,
                            class: _normalizeClass(["px-3 py-1 rounded-full border text-sm", 
                  isMethodSelected(attributeName, method.id)
                    ? 'border-green-500 bg-green-50 text-green-600'
                    : 'border-gray-300 text-gray-600'
                ]),
                            onClick: ($event: any) => (toggleMethodSelection(attributeName, method.id))
                          }, _toDisplayString(method.name), 11, _hoisted_115))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "flex space-x-3" }, [
              _createElementVNode("button", {
                class: "flex-1 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50",
                onClick: hideSpecModal
              }, " 取消 "),
              _createElementVNode("button", {
                class: "flex-1 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600",
                onClick: confirmAddToOrder
              }, " 确认添加 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (discountModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
              _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "text-xl font-bold" }, "编辑折扣金额", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                onClick: cancelEditDiscount
              }, _cache[45] || (_cache[45] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", null, [
                _cache[47] || (_cache[47] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 折扣金额（元） ", -1)),
                _createElementVNode("input", {
                  type: "text",
                  value: tempDiscountAmount.value,
                  placeholder: "请输入折扣金额",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-lg",
                  onInput: handleDiscountInput
                }, null, 40, _hoisted_119)
              ]),
              _createElementVNode("div", null, [
                _cache[48] || (_cache[48] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 备注信息 ", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tempDiscountRemark).value = $event)),
                  placeholder: "请输入备注信息（可选）",
                  rows: "3",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-base resize-none"
                }, null, 512), [
                  [_vModelText, tempDiscountRemark.value]
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex space-x-3 pt-6 mt-6 border-t" }, [
              _createElementVNode("button", {
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
                onClick: cancelEditDiscount
              }, " 取消 "),
              _createElementVNode("button", {
                class: "flex-1 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium",
                onClick: saveDiscountAmount
              }, " 保存 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (paymentConfirmModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
              _cache[50] || (_cache[50] = _createElementVNode("h3", { class: "text-xl font-bold" }, "选择支付方式", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                onClick: hidePaymentConfirmModal
              }, _cache[49] || (_cache[49] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("div", null, [
                _cache[51] || (_cache[51] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 支付方式 ", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedPaymentMethod).value = $event)),
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-lg"
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentMethods, (method) => {
                    return _createElementVNode("option", {
                      key: method.value,
                      value: method.value
                    }, _toDisplayString(method.name), 9, _hoisted_123)
                  }), 64))
                ], 512), [
                  [_vModelSelect, selectedPaymentMethod.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[52] || (_cache[52] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " 备注信息 ", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((paymentRemark).value = $event)),
                  placeholder: "请输入备注信息（可选）",
                  rows: "3",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-base resize-none"
                }, null, 512), [
                  [_vModelText, paymentRemark.value]
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex space-x-3 pt-6 mt-6 border-t" }, [
              _createElementVNode("button", {
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
                onClick: hidePaymentConfirmModal
              }, " 取消 "),
              _createElementVNode("button", {
                class: "flex-1 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium",
                onClick: confirmPayment
              }, " 确认支付 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (scanPaymentModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
          _createElementVNode("div", { class: "bg-black bg-opacity-80 text-white px-4 py-3 flex items-center justify-between" }, [
            _createElementVNode("button", {
              class: "text-white",
              onClick: hideScanPaymentModal
            }, _cache[53] || (_cache[53] = [
              _createElementVNode("i", { class: "fas fa-times text-2xl" }, null, -1)
            ])),
            _cache[54] || (_cache[54] = _createElementVNode("h3", { class: "text-xl font-bold" }, "扫码支付", -1)),
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "w-8" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_125, [
            _cache[57] || (_cache[57] = _createElementVNode("div", {
              id: "qr-reader",
              class: "qr-reader-container w-full h-full"
            }, null, -1)),
            (isScanning.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_126, _cache[56] || (_cache[56] = [
                  _createElementVNode("div", { class: "scan-line" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          (scanStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                _createElementVNode("div", {
                  class: _normalizeClass(["p-3 rounded-lg text-center", scanStatusClass.value])
                }, [
                  _createElementVNode("p", _hoisted_128, _toDisplayString(scanStatus.value), 1)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (scanPaymentFailModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
          _createElementVNode("div", _hoisted_130, [
            _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
              _cache[59] || (_cache[59] = _createElementVNode("h3", { class: "text-xl font-bold" }, "支付确认", -1)),
              _createElementVNode("button", {
                class: "text-gray-500 hover:text-gray-700",
                onClick: cancelScanPaymentConfirm
              }, _cache[58] || (_cache[58] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _cache[61] || (_cache[61] = _createElementVNode("div", { class: "mb-6" }, [
              _createElementVNode("p", { class: "text-gray-700 text-lg" }, " 扫码支付返回失败，请确认客户是否已经完成支付？ ")
            ], -1)),
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("button", {
                class: "flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
                onClick: cancelScanPaymentConfirm
              }, " 取消 "),
              _createElementVNode("button", {
                disabled: isRefreshingPayment.value,
                class: _normalizeClass([
              'flex-1 py-3 rounded-lg transition-colors font-medium',
              isRefreshingPayment.value
                ? 'bg-gray-400 text-white cursor-not-allowed'
                : 'bg-green-500 text-white hover:bg-green-600',
            ]),
                onClick: confirmScanPaymentPaid
              }, [
                (isRefreshingPayment.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_133, _cache[60] || (_cache[60] = [
                      _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                      _createTextVNode("确认支付中 ", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_134, "确认已经支付"))
              ], 10, _hoisted_132)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmDialog, {
      ref_key: "confirmDialog",
      ref: confirmDialog,
      message: confirmMessage.value,
      title: confirmTitle.value
    }, null, 8, ["message", "title"])
  ]))
}
}

})